<template>
  <div id="product-list">
    <div class="breadcrum pb-2 pt-2">
      <div class="container">
        <router-link class="color-black" :to="{ name: 'home' }"><i class="fas fa-home"></i></router-link> <i class="fa fa-angle-right mx-1"></i>
        <template v-if="is_tyre_link">
          <a href="javascript:void(0)" @click="resetTheFilter('All')">{{ $t("Tyres") }} </a> <i class="fa fa-angle-right mx-1"></i>
        </template>
        <template v-else><span>{{ $t("Tyres") }}</span> <span v-if="vehicleTypes && vehicleTypes.length === 1"><i class="fa fa-angle-right mx-1"></i></span> </template>

        <template v-if="tyre_category && tyre_category.id !== 1">
          <template v-if="is_tyre_category_link">
            <a href="javascript:void(0)" @click="changeVehicleType(tyre_category.vehicle_type)">{{ tyre_category_name }}</a><i class="fa fa-angle-right mx-1"></i>
          </template>
          <template v-else><span>{{ tyre_category_name }}</span></template>
        </template>

        <template v-if="is_tyre_size_link"><a href="javascript:void(0)" @click="move_to_size()" v-html="tyres_size_breadcrumb_html"></a> <i class="fa fa-angle-right mx-1"></i></template>
        <template v-else> <span v-html="tyres_size_breadcrumb_html"></span> </template>

        <template v-if="selectedTyreSeasons"><span ref="tyre_season_breadcrumb" v-html="tyres_season_breadcrumb_html"></span></template>
        <template v-if="selectedBrands"><span ref="brand_breadcrumb" v-html="tyres_brand_breadcrumb_html"></span></template>
        <template v-if="selectedSpeedIndexes"><span ref="speed_index_breadcrumb" v-html="tyre_speed_index_breadcrumb_html"></span></template>
        <template v-if="selectedFuelEfficiencies"><span ref="fuel_efficiency_breadcrumb" v-html="tyre_fuel_efficiencies_breadcrumb_html"></span></template>
        <template v-if="selectedWetGrips"><span ref="fuel_wet_grip_breadcrumb" v-html="tyre_wet_grips_breadcrumb_html"></span></template>
        <template v-if="selectedNoiseClasses"><span ref="fuel_noise_class_breadcrumb" v-html="tyre_noice_classes_breadcrumb_html"></span></template>
        <template v-if="selectedNoiseValues"><span ref="fuel_noise_value_breadcrumb" v-html="tyre_noice_values_breadcrumb_html"></span></template>
        <template v-if="selectedLoadIndexes"><span ref="fuel_load_index_breadcrumb" v-html="tyre_load_index_breadcrumb_html"></span></template>
      </div>
    </div>

    <div class="container pt-3">
      <div class="row">
        <div class="col-md-4 col-lg-4 col-xl-3">
          <button class="btn bg-yellow mb-3 d-block" @click="myFilter" id="filterBtn"> {{ $t("Filter search") }} <i
              class="fas fa-bars ml-2"></i></button>
          <div class="filter-area " :class="{showDiv: isActive}" id="filterDiv">


            <div class="filter-box mb-4 p-3">
              <div class="filter-title">
                <p class="mb-2 d-block color-gray text-uppercase">
                  {{ $t("Service Point") }}
                </p>
              </div>

              <div class="filter-data">
                <div class="row" v-if="address !== ''">
                  <div class="col-12 mb-0">
                    <p class="mb-0 font-weight-bold">{{ $t("Nearby Area") }}</p>
                    <p class="mb-0 font-18 font-italic">{{ address }}</p>
                  </div>
                </div>
                <div class="row" v-if="selectedServicePoint !== null && checkIsServicePointAvailable()">
                  <div class="col-12">
                    <hr class="mt-1 mb-1">
                    <ul id="service-point-address">
                      <li id="organization-name">{{ selectedServicePoint.company_name }}</li>
                      <li id="distance-icon">{{ parseFloat(selectedServicePoint.distance_km).toFixed(2) }} {{
                          $t('km')
                        }}
                      </li>
                      <li id="address-icon">{{ selectedServicePoint.address_line_1 }}
                        {{ selectedServicePoint.address_line_2 }}
                      </li>
                      <li>{{ selectedServicePoint.zipcode }}, {{ selectedServicePoint.city }}</li>
                      <li id="time-icon" v-if="selectedServicePoint.time_slots.length">
                        {{ nextAvailableSlotDateCommon(selectedServicePoint) }}
                      </li>
                      <li id="phone-icon" v-else>{{ $t('Appointment by phone') }} : <p>{{ $t('tel') }}.
                        {{ selectedServicePoint.contact_number }}</p></li>
                    </ul>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 pt-2">
                    <button
                        v-b-modal.modal-1
                        type="button"
                        class="btn bg-yellow font-weight-bold text-uppercase w-100 d-block pt-2 pb-2 mb-2">
                      {{ selectedServicePoint !== null ? $t('Change') : $t('Select') }} {{ $t('Service Point') }}
                    </button>

                    <button
                        v-if="address !== ''"
                        type="button"
                        @click="clearSearchedServicePoint()"
                        class="btn bg-yellow font-weight-bold text-uppercase w-100 d-block pt-2 pb-2">
                      {{ $t('Reset') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="filter-box mb-4 p-3">
              <div class="filter-title">
                <p class="mb-2 d-block color-gray text-uppercase">
                  {{ $t("Tyre Size") }}
                </p>
              </div>

              <div class="filter-data">
                <form class="form-inline">
                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="justify-content-start mb-2">{{ $t("Vehicle Type") }}</label>
                      <b-form-select
                          v-model="vehicleType"
                          id="carType"
                          name="carType"
                          @change="changeVehicleType($event)"
                          class=""
                          value-field="car_type"
                          text-field="car_type">
                        <b-form-select-option v-for="vehicleType in vehicleTypes" :value="vehicleType.car_type"
                                              :key="vehicleType.car_type">
                          <span v-if="vehicleType.car_type == 'All'">{{ $t('All') }}</span>
                          <span v-else-if="vehicleType.car_type == 'Car'">{{ $t('Car/SUV/4X4') }}</span>
                          <span v-else-if="vehicleType.car_type == 'Light Truck'">{{ $t('Light Commercial Vehicle') }}</span>
                        </b-form-select-option>
                      </b-form-select>
                    </div>
                    <div class="col-12 mb-2 row pr-0">
                      <label class="justify-content-start col-4 col-md-12 col-lg-4">{{ $t("Width") }}</label>
                      <div class="col-8 col-md-12 col-lg-8 pr-0">
                        <b-form-select
                            v-model="searchBySize.width"
                            id="widths"
                            name="widths"
                            @change="changeWidth($event)"
                            :options="widths"
                            value-field="width"
                            text-field="width">
                          <template v-slot:first>
                            <b-form-select-option :value="null" disabled>{{ $t('Width') }}</b-form-select-option>
                          </template>
                        </b-form-select>
                      </div>

                    </div>
                    <div class="col-12 mb-2 row pr-0">
                      <label class="justify-content-start col-4  col-md-12 col-lg-4">{{ $t("Height") }}</label>
                      <div class="col-8 pr-0  col-md-12 col-lg-8">
                        <b-form-select
                            v-model="searchBySize.height"
                            id="height"
                            name="height"
                            @change="changeHeight($event)"
                            :disabled="searchBySize.width == null"
                            class="custom-select"
                            :options="heights"
                            value-field="aspect_ratio"
                            text-field="aspect_ratio">
                          <template v-slot:first>
                            <b-form-select-option :value="null" disabled>{{ $t('Height') }}</b-form-select-option>
                          </template>
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-12 mb-2 row pr-0">
                      <label class="justify-content-start col-4  col-md-12 col-lg-4">{{ $t("Diameter") }}</label>
                      <div class="col-8 pr-0  col-md-12 col-lg-8">
                        <b-form-select
                            v-model="searchBySize.diameter"
                            id="diameter"
                            name="diameter"
                            @change="changeDiameter($event)"
                            :disabled="searchBySize.width == null || searchBySize.height == null"
                            class="custom-select"
                            :options="diameters"
                            value-field="diameter"
                            text-field="diameter">
                          <template v-slot:first>
                            <b-form-select-option :value="null" disabled>{{ $t('Diameter') }}</b-form-select-option>
                          </template>
                        </b-form-select>
                      </div>
                    </div>

                    <div class="col-12 pt-2" v-if="resetEnabled">
                      <button
                          type="button"
                          @click="resetTheFilter('All')"
                          class="btn bg-yellow font-weight-bold text-uppercase w-100 d-block pt-2 pb-2">
                        {{ $t('Reset') }}
                      </button>
                    </div>
                    <div class="col-12 pt-2" v-else>
                      <button
                          type="button"
                          @click="searchByTyreSize()"
                          :disabled="(searchBySize.width == null || searchBySize.height == null || searchBySize.diameter == null)"
                          class="bg-yellow btn font-weight-bold text-uppercase w-100 d-block pt-2 pb-2">
                        <i class="fas fa-search"></i> {{ $t('Search Tyres') }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <!-- <div class="filter-box mb-4">
                <div class="filter-title mb-4">
                    <a data-toggle="collapse" class="p-3 d-block color-gray" href="#priceRange" aria-expanded="false" aria-controls="collapseExample">
                        {{ $t("Price range") }}
                    </a>
                </div>


                <div class="collapse show" id="priceRange">
                    <div class="filter-data pt-0 pb-4 pl-3 pr-3"> -->


            <!-- <div class="range-slider">
                <span @change="slider">from
                    <input
                        v-model.number="minPrice"
                        type="number"
                        min="0"
                        max="120000"/> to
                    <input
                        v-model.number="maxPrice"
                        type="number"
                        min="0"
                        max="120000"/>
                </span>
                    <input
                        @change="slider"
                        v-model.number="minPrice"
                        min="0"
                        max="120000"
                        step="500"
                        type="range" />
                    <input
                        @change="slider"
                        v-model.number="maxPrice"
                        min="0"
                        max="120000"
                        step="500"
                        type="range" />
                    <svg width="100%" height="24">
                        <line x1="4" y1="0" x2="300" y2="0" stroke="#444" stroke-width="12" stroke-dasharray="1 28"></line>
                    </svg>
            </div> -->


            <!-- <vue-range-slider
                id="slider-range"
                class="ml-2 mr-2"
                v-model="selectedPriceRanges"
                :min="priceRangesMin"
                :max="priceRangesMax"
                :enable-cross="enableCross"
            >
            </vue-range-slider> -->


            <!-- <el-slider
                v-model="selectedPriceRanges"
                range=""
                show-stops
                :max="priceRangesMax">
            </el-slider> -->

            <!-- <vue-slider
                ref="slider"
                v-model="selectedPriceRanges"
                v-bind="options"
            ></vue-slider>
    </div>
</div>
</div> -->

            <!-- @drag-start="() => inDragging = true"
            @drag-end="() => inDragging = false" -->


            <div class="filter-box mb-4">
              <div class="filter-title mb-4">
                <a data-toggle="collapse" class="p-3 d-block color-gray" href="#priceRange" aria-expanded="false"
                   aria-controls="collapseExample">
                  {{ $t("Price range") }}
                </a>
              </div>

              <div class="collapse show" id="priceRange">
                <div class="filter-data pt-0 pb-4 pl-4 pr-4">
                  <div v-if="priceRangesMin != 0 && priceRangesMax != 0">
                    <vue-slider
                        v-model="selectedPriceRanges"
                        :min="priceRangesMin"
                        :max="priceRangesMax"
                        :interval="1"
                        :drag-on-click="true"
                        :enable-cross="false"
                        @drag-end="selectedPriceRangesChange()"
                        :dot-options="[{ tooltip: 'always' }, {tooltip: 'always' }]"

                    >

                      <!-- :tooltip="'always'" -->
                      <template v-slot:tooltip="{ value }">
                        <div>{{ value }}€</div>
                      </template>

                    </vue-slider>
                  </div>
                </div>
              </div>
            </div>

            <div class="filter-box mb-4">
              <div class="filter-title">
                <a
                    data-toggle="collapse"
                    class="p-3 d-block color-gray collapsed"
                    href="#season"
                    aria-expanded="false"
                    aria-controls="collapseExample">
                  {{ $t("Season / Tyre Type") }}
                  <i class="fas fa-chevron-down"></i>
                </a>
              </div>

              <div class="collapse" id="season">
                <div class="filter-data pt-0 pl-3 pr-3 pb-3">
                  <div class="" v-if="tyreSeasons && tyreSeasons.length > 0">

                    <b-form-group>

                      <b-form-checkbox
                          v-model="allSelectedTyreSeasons"
                          :indeterminate="indeterminateTyreSeasons"
                          aria-describedby="tyreSeasons"
                          aria-controls="tyreSeasons"
                          @change="toggleAllTyreSeasons"
                      >
                        {{ $t("All") }}
                      </b-form-checkbox>

                      <b-form-checkbox-group id="checkbox-group-3" v-model="selectedTyreSeasons" name="flavour-3">
                        <div class="col-12 mb-2" v-for="tyreSeason in tyreSeasons" :key="tyreSeason.id">
                          <!-- <span v-for="filTyreSeason in filTyreSeasons" :key="`fil_tyreseason`+filTyreSeason.id"> -->
                          <!-- :disabled="tyreSeason.id != filTyreSeason.id" -->
                          <b-form-checkbox
                              :id="'tyreseason_'+tyreSeason.id"
                              :disabled="checkFilTyreSeasons(tyreSeason.id)"
                              :value="tyreSeason.name">
                            <label
                                class="custom-control-label"
                                :for="'tyreseason_'+tyreSeason.id">{{ $t(tyreSeason.name) }}</label>
                          </b-form-checkbox>
                          <!-- </span> -->
                        </div>
                      </b-form-checkbox-group>
                    </b-form-group>

                  </div>
                </div>
              </div>
            </div>

            <div class="filter-box mb-4">

              <div class="filter-title">
                <a data-toggle="collapse" class="p-3 d-block color-gray" href="#brands" aria-expanded="false"
                   aria-controls="collapseExample">
                  {{ $t("Brands") }}
                  <i class="fas fa-chevron-down"></i>
                </a>
              </div>
              <div class="collapse" id="brands">
                <div class="filter-data pt-0 pl-3 pr-3 pb-3">
                  <div class="" v-if="brands && brands.length > 0">

                    <b-form-group label="">

                      <b-form-checkbox
                          v-model="allSelectedBrands"
                          :indeterminate="indeterminateBrands"
                          aria-describedby="brands"
                          aria-controls="brands"
                          @change="toggleAllBrands"
                      >
                        All
                      </b-form-checkbox>
                      <b-form-checkbox-group id="checkbox-group-2" v-model="selectedBrands" name="flavour-2">
                        <template v-for="brand in brands">
                          <div class="col-12 mb-2" v-if="!checkFilBrands(brand.id)" :key="brand.id">
                            <!-- <span v-for="filBrand in filBrands" :key="`fil_brand`+filBrand.id"> -->
                            <b-form-checkbox
                                :id="'brand_'+brand.id"
                                :disabled="checkFilBrands(brand.id)"
                                :value="brand.name">
                              <label
                                  class="custom-control-label"
                                  :for="'brand_'+brand.id">{{ brand.name }}</label>
                            </b-form-checkbox>
                            <!-- </span> -->
                          </div>
                        </template>
                      </b-form-checkbox-group>
                    </b-form-group>

                  </div>
                </div>
              </div>
            </div>

            <div class="filter-box mb-4">
              <div class="filter-title">
                <a data-toggle="collapse" class="p-3 d-block color-gray collapsed" href="#speedIndexes"
                   aria-expanded="false" aria-controls="collapseExample">
                  {{ $t("Speed Index") }}
                  <i class="fas fa-chevron-down"></i>
                </a>
              </div>

              <div class="collapse" id="speedIndexes">
                <div class="filter-data pt-0 pl-3 pr-3 pb-3">
                  <div class="" v-if="speedIndexes && speedIndexes.length > 0">

                    <b-form-group label="">

                      <b-form-checkbox
                          v-model="allSelectedSpeedIndexes"
                          :indeterminate="indeterminateSpeedIndexes"
                          aria-describedby="speedIndexes"
                          aria-controls="speedIndexes"
                          @change="toggleAllSpeedIndexes"
                      >
                        {{ $t("All") }}
                      </b-form-checkbox>

                      <b-form-checkbox-group id="checkbox-group-3" v-model="selectedSpeedIndexes" name="flavour-3" class="row">
                        <template v-for="speedIndex in speedIndexes">
                          <div class="col-6 mb-2" v-if="!checkFilSpeedIndexes(speedIndex.speed_index)"
                               :key="speedIndex.speed_index">
                            <!-- <span v-for="filSpeedIndex in filSpeedIndexes" :key="`fil_speedindex`+filSpeedIndexes.speed_index"> -->
                            <!-- :disabled="speedIndex.speed_index != filSpeedIndex.speed_index" -->
                            <b-form-checkbox
                                :id="'speedindex_'+speedIndex.speed_index"
                                :disabled="checkFilSpeedIndexes(speedIndex.speed_index)"
                                :value="speedIndex.speed_index">
                              {{ speedIndex.speed_index }}
                            </b-form-checkbox>
                            <!-- </span> -->
                          </div>
                        </template>
                      </b-form-checkbox-group>
                    </b-form-group>

                  </div>
                </div>
              </div>
            </div>

            <div class="filter-box mb-4">

              <div class="filter-title">
                <a data-toggle="collapse" class="p-3 d-block color-gray" href="#fuelEfficiencies" aria-expanded="false"
                   aria-controls="collapseExample">
                  {{ $t("Fuel Efficiency") }}
                  <i class="fas fa-chevron-down"></i>
                </a>
              </div>
              <div class="collapse" id="fuelEfficiencies">
                <div class="filter-data pt-0 pl-3 pr-3 pb-3">
                  <div class="" v-if="fuelEfficiencies && fuelEfficiencies.length > 0">


                    <b-form-group label="">
                      <b-form-checkbox
                          v-model="allSelectedFuelEfficiencies"
                          :indeterminate="indeterminateFuelEfficiencies"
                          aria-describedby="fuelEfficiencies"
                          aria-controls="fuelEfficiencies"
                          @change="toggleAllFuelEfficiencies"
                      >
                        {{ $t("All") }}
                      </b-form-checkbox>

                      <b-form-checkbox-group id="checkbox-group-2" v-model="selectedFuelEfficiencies" name="flavour-2" class="row">
                        <template v-for="fuelEfficiency in fuelEfficiencies">
                          <div class="col-6 mb-2" v-if="!checkFilFuelEfficiencies(fuelEfficiency.fuel_efficiency)"
                               :key="fuelEfficiency.fuel_efficiency">
                            <!-- <span v-for="filFuelEfficiency in filFuelEfficiencies" :key="`fil_fuel_efficiency`+filFuelEfficiency.fuel_efficiency"> -->
                            <!-- :disabled="fuelEfficiency.fuel_efficiency != filFuelEfficiency.fuel_efficiency" -->
                            <b-form-checkbox
                                :id="'fuelEfficiency_'+fuelEfficiency.fuel_efficiency"
                                :disabled="checkFilFuelEfficiencies(fuelEfficiency.fuel_efficiency)"
                                :value="fuelEfficiency.fuel_efficiency">
                              <!-- <label
                                  class="custom-control-label"
                                  :for="'fuelEfficiency_'+fuelEfficiency.fuel_efficiency">
                                  {{fuelEfficiency.fuel_efficiency}}
                              </label> -->

                              <ul class="eulabels">
                                <li>
                                                                            <span class="eulabels-tag fuel-tag"
                                                                                  :class="`level-`+fuelEfficiency.fuel_efficiency">
                                                                                <i class="fas fa-gas-pump"></i> 
                                                                                {{ fuelEfficiency.fuel_efficiency }}
                                                                            </span>
                                </li>
                              </ul>
                            </b-form-checkbox>
                            <!-- </span> -->
                          </div>
                        </template>
                      </b-form-checkbox-group>
                    </b-form-group>

                  </div>
                </div>
              </div>
            </div>

            <div class="filter-box mb-4">

              <div class="filter-title">
                <a data-toggle="collapse" class="p-3 d-block color-gray" href="#wetgrips" aria-expanded="false"
                   aria-controls="collapseExample">
                  {{ $t("Wet Grip") }}
                  <i class="fas fa-chevron-down"></i>
                </a>
              </div>
              <div class="collapse" id="wetgrips">
                <div class="filter-data pt-0 pl-3 pr-3 pb-3">
                  <div class="" v-if="wetGrips && wetGrips.length > 0">

                    <b-form-group label="">
                      <b-form-checkbox
                          v-model="allSelectedWetGrips"
                          :indeterminate="indeterminateWetGrips"
                          aria-describedby="wetGrips"
                          aria-controls="wetGrips"
                          @change="toggleAllWetGrips"
                      >
                        {{ $t("All") }}
                      </b-form-checkbox>

                      <b-form-checkbox-group id="checkbox-group-2" v-model="selectedWetGrips" name="flavour-2" class="row">
                        <template v-for="wetGrip in wetGrips">
                          <div class="col-6 mb-2" v-if="!checkFilWetGrips(wetGrip.wet_grip)" :key="wetGrip.wet_grip">
                            <!-- <span v-for="filWetGrip in filWetGrips" :key="`fil_wetgrip`+filWetGrip.wet_grip"> -->
                            <!-- :disabled="wetGrip.wet_grip != filWetGrip.wet_grip" -->
                            <b-form-checkbox
                                :id="'wetGrip_'+wetGrip.wet_grip"
                                :disabled="checkFilWetGrips(wetGrip.wet_grip)"
                                :value="wetGrip.wet_grip">
                              <!-- <label
                                  class="custom-control-label"
                                  :for="'wetGrip_'+wetGrip.wet_grip">{{wetGrip.wet_grip}}</label> -->

                              <ul class="eulabels">
                                <li>
                                                                            <span class="eulabels-tag wet-tag"
                                                                                  :class="`level-`+wetGrip.wet_grip">
                                                                                <i class="fas fa-cloud-showers-heavy"></i>
                                                                                {{ wetGrip.wet_grip }}
                                                                            </span>
                                </li>
                              </ul>
                            </b-form-checkbox>
                            <!-- </span> -->
                          </div>
                        </template>
                      </b-form-checkbox-group>
                    </b-form-group>

                  </div>
                </div>
              </div>
            </div>

            <div class="filter-box mb-4">

              <div class="filter-title">
                <a data-toggle="collapse" class="p-3 d-block color-gray" href="#noiseClasses" aria-expanded="false"
                   aria-controls="collapseExample">
                  {{ $t("Noice Class") }}
                  <i class="fas fa-chevron-down"></i>
                </a>
              </div>

              <div class="collapse" id="noiseClasses">
                <div class="filter-data pt-0 pl-3 pr-3 pb-3">
                  <div class="" v-if="noiseClasses && noiseClasses.length > 0">

                    <b-form-group label="">

                      <b-form-checkbox
                          v-model="allSelectedNoiseClasses"
                          :indeterminate="indeterminateNoiseClasses"
                          aria-describedby="noiseClasses"
                          aria-controls="noiseClasses"
                          @change="toggleAllNoiseClasses"
                      >
                        {{ $t("All") }}
                      </b-form-checkbox>

                      <b-form-checkbox-group id="checkbox-group-2" v-model="selectedNoiseClasses"  name="flavour-2">
                        <template v-for="noiseClass in noiseClasses">
                          <div class="col-12 mb-2" v-if="!checkNoiseClasses(noiseClass.noice_class)"
                               :key="noiseClass.noice_class">
                            <!-- <span v-for="filNoiseClass in filNoiseClasses" :key="`fil_noice_class`+filNoiseClass.noice_class"> -->
                            <!-- :disabled="noiseClass.noice_class != filNoiseClass.noice_class" -->
                            <b-form-checkbox
                                :id="'noiseClass_'+noiseClass.noice_class"
                                :disabled="checkNoiseClasses(noiseClass.noice_class)"
                                :value="noiseClass.noice_class">
                              <label
                                  class="custom-control-label"
                                  :for="'noiseClass_'+noiseClass.noice_class">{{ noiseClass.noice_class }}</label>
                            </b-form-checkbox>
                            <!-- </span> -->
                          </div>
                        </template>
                      </b-form-checkbox-group>
                    </b-form-group>

                  </div>
                </div>
              </div>
            </div>

            <div class="filter-box mb-4">

              <div class="filter-title">
                <a data-toggle="collapse" class="p-3 d-block color-gray" href="#noiceValues" aria-expanded="false"
                   aria-controls="collapseExample">
                  {{ $t("Noice Value") }}
                  <i class="fas fa-chevron-down"></i>
                </a>
              </div>

              <div class="collapse" id="noiceValues">
                <div class="filter-data pt-0 pl-3 pr-3 pb-3">
                  <div class="" v-if="noiseValues && noiseValues.length > 0">

                    <b-form-group label="">
                      <b-form-checkbox
                          v-model="allSelectedNoiseValues"
                          :indeterminate="indeterminateNoiseValues"
                          aria-describedby="noiseValues"
                          aria-controls="noiseValues"
                          @change="toggleAllNoiseValues"
                      >
                        {{ $t("All") }}
                      </b-form-checkbox>

                      <b-form-checkbox-group id="checkbox-group-2" v-model="selectedNoiseValues" name="flavour-2" class="row">
                        <template v-for="noiseValue in noiseValues">
                          <div class="col-6 mb-2" v-if="!checkNoiseValues(noiseValue.noice_value)"
                               :key="noiseValue.noice_value">
                            <!-- <span v-for="filNoiseValue in filNoiseValues" :key="`fil_noice_value`+filNoiseValue.noice_value"> -->
                            <!-- :disabled="noiseValue.noice_value != filNoiseValue.noice_value" -->
                            <b-form-checkbox
                                :id="'noiseValue_'+noiseValue.noice_value"
                                :disabled="checkNoiseValues(noiseValue.noice_value)"
                                :value="noiseValue.noice_value">

                              <ul class="eulabels" :for="'noiseValue_'+noiseValue.noice_value">
                                <li>
                                    <span class="eulabels-tag noice-tag">
                                        <i class="fas">
                                            <img
                                                v-if="noiseValue.noice_value < 69"
                                                src="../../public/images/volumeicon/vol1.png"/>
                                            <img
                                                v-else-if="noiseValue.noice_value >= 69 && noiseValue.noice_value < 73"
                                                src="../../public/images/volumeicon/vol2.png"/>
                                            <img v-else
                                                 src="../../public/images/volumeicon/vol3.png"/>
                                            {{ noiseValue.noice_value }}
                                        </i>

                                    </span>

                                </li>
                              </ul>

                              <!-- <label
                                  class="custom-control-label"
                                  :for="'noiseValue_'+noiseValue.noice_value">{{noiseValue.noice_value}}</label> -->
                            </b-form-checkbox>
                            <!-- </span> -->
                          </div>
                        </template>
                      </b-form-checkbox-group>
                    </b-form-group>

                  </div>
                </div>
              </div>
            </div>

            <div class="filter-box mb-4">
              <div class="filter-title">
                <a data-toggle="collapse" class="p-3 d-block color-gray" href="#loadIndexes" aria-expanded="false"
                   aria-controls="collapseExample">
                  {{ $t("Load Index") }}
                  <i class="fas fa-chevron-down"></i>
                </a>
              </div>

              <div class="collapse" id="loadIndexes">
                <div class="filter-data pt-0 pl-3 pr-3 pb-3">
                  <div class="" v-if="loadIndexes && loadIndexes.length > 0">

                    <b-form-group label="">

                      <b-form-checkbox
                          v-model="allSelectedLoadIndexes"
                          :indeterminate="indeterminateLoadIndexes"
                          aria-describedby="loadIndexes"
                          aria-controls="loadIndexes"
                          @change="toggleAllLoadIndexes"
                      >
                        {{ $t("All") }}
                      </b-form-checkbox>

                      <b-form-checkbox-group id="checkbox-group-3" v-model="selectedLoadIndexes" name="flavour-3" class="row">
                        <template v-for="loadIndex in loadIndexes">
                          <div class="col-12 mb-2" v-if="!checkFilLoadIndexes(loadIndex.load_index)"
                               :key="loadIndex.load_index">
                            <!-- <span v-for="filLoadIndex in filLoadIndexes" :key="`fil_load_index`+filLoadIndex.load_index"> -->
                            <!-- :disabled="loadIndex.load_index != filLoadIndex.load_index" -->
                            <b-form-checkbox
                                :id="'loadindex_'+loadIndex.load_index"
                                :disabled="checkFilLoadIndexes(loadIndex.load_index)"
                                :value="loadIndex.load_index">
                              <label
                                  class="custom-control-label"
                                  :for="'loadindex_'+loadIndex.load_index">{{ loadIndex.load_index }}</label>
                            </b-form-checkbox>
                            <!-- </span> -->
                          </div>
                        </template>
                      </b-form-checkbox-group>
                    </b-form-group>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="col-md-8 col-lg-8 col-xl-9">
          <div class="product-area">
            <div v-if="!loading"
                 class="product-sorting d-flex justify-content-between pt-2 pb-2 align-items-center mb-3 flex-wrap">
              <p class="font-14 mb-4 mb-sm-0"><span
                  class="font-weight-bold text-danger"> {{ totalProducts }} {{ $t('Results') }} </span>
                <template v-if="currentLang === 'en_GB'"> {{ $t("for") }} </template>
                <template v-if="tyre_category && tyre_category.id !== 1">
                  <span class="text-lowercase">{{ tyre_category_name }}</span>
                </template>
                <template v-else>
                  <span class="text-lowercase">{{ $t("All") }} {{ $t("Tyres") }}</span>
                </template>
              </p>
              <div class="col-12 col-sm-4 d-flex align-items-center justify-content-end">
                <label class="mr-2 mb-0" v-html="$t('Sort&nbsp;by')"></label>
                <!-- <select name="sorting" class="custom-select">
                    <option selected>Popularity</option>
                    <option value="price">Price</option>
                    <option value="availability">Availability</option>
                    <option @click="sort('name', 'asc')" value="price">Name: A-Z</option>
                    <option @click="sort('name', 'dsc')" value="price">Name: Z-A</option>
                    <option @click="sort('price', 'asc')" value="price">Price: Asc</option>
                    <option @click="sort('price', 'dsc')" value="price">Price: Desc</option>
                </select> -->


                <b-form-select v-model="selected" @change="sort($event)" class="custom-select">

                  <option :value="{ Name: 'name', order: 'Asc' }">{{ $t('Name: A-Z') }}</option>
                  <option :value="{ Name: 'name', order: 'Desc' }">{{ $t('Name: Z-A') }}</option>
                  <option :value="{ Name: 'net_price', order: 'Asc' }">{{ $t('Price: Low to high') }}</option>
                  <option :value="{ Name: 'net_price', order: 'Desc' }">{{ $t('Price: High to low') }}</option>
                </b-form-select>

                <!-- <b-form-select
                    @change="sort($event)"
                    v-model="selected"
                    :options="optionSorting"
                    class="custom-select"></b-form-select> -->

              </div>
            </div>

            <center>
              <b-alert :show="showSuccessAlert" dismissible @dismissed="showSuccessAlert=0" variant="success"
                       class="w-50">
                <i class="fa fa-check-circle"></i>
                {{ $t('Item added into cart successfully') }}
              </b-alert>
            </center>

            <div class="product-listing">
              <div class="row">

                <!-- {{products}} -->

                <!-- <div v-for="product in products" :key="product.id" class="col-md-12 col-lg-6">
                    <div  :class="{ 'soldout' : product.in_stock <= 0 }" class="product-item d-flex mb-4 offer">
                        <span class="productoffer">Offer</span>
                        <div class="product-image">
                            <i class="icon-winter"></i>
                            <p><img src="images/tyre-img.png"> </p>
      <p class="mb-0"><img src="images/client-logo-1.jpg"> </p>
                        </div>
                        <div class="product-info">
                            <h3>{{product.name}}</h3>
                            <p class="mb-2"><img src="/images/tyre-icon-1.jpg"></p>
                            <p class="mb-2"><img src="/images/tyre-icon-2.jpg"></p>
                            <p class="mb-3"><img src="/images/tyre-icon-3.jpg"></p>
                            <p class="price font-weight-bold text-center pt-2 pb-2">€95</p>
                            <router-link
                                class="btn btn-add-cart p-2 text-center w-100 mb-2 bg-black rounded color-white"
                                :to="{ name: 'cart' }">
                                <span> {{ $t('Add to Cart') }} </span>
                            </router-link>
                            <router-link
                                class="view-details d-block p-2 text-center bg-yellow color-white"
                                :to="{ name: 'product-details' }">
                                <span> {{ $t('View Details') }} </span>
                            </router-link>
                        </div>
                    </div>
                </div> -->

                <!-- <div class="pagination-area">
                    <pagination
                        :items="products"
                        v-on:page:update="updatePage"
                        :currentPage="currentPage"
                        :pageSize="pageSize"
                        :type="type"
                        totalRecords="1744">
                    </pagination>
                </div> -->


                <!-- <div class="images-container">
                    <div class="images-item" v-for="(image,index) of images" :key="index">
                        <div class="images-card">
                        <img class="images-card__image" :src="image.urls.small" @load="masks.push(index)">
                        <div class="images-card__mask" :style="{'background-color':image.color}" v-if="!masks.includes(index)"></div>
                        </div>
                    </div>
                </div> -->

                <div v-if="loading" class="loading"></div>

                <b-alert :show="noDataFoundStatus" class="col-md-12 col-lg-12" outlined
                         style="color:white;background-color: #e3484d !important;border-color: #e3484d !important;">
                  <center>{{ $t("No result found") }}</center>
                </b-alert>

                <div v-for="product in products" :key="product.id" class="col-md-12 col-lg-6">
                  <div :class="{ 'soldout' : product.in_stock <= 0 }" class="product-item d-flex mb-4 offer">
                    <b-link
                        :to="makeBreadcrumbLink(product)"
                        class="product-image">
                      <div
                          v-if="product.image"
                          class="plimg"
                          :aria-label="product.name"
                          :style="getImageURL(product)">
                      </div>
                      <div
                          v-else
                          class="plimg"
                          :aria-label="product.name"
                          style="background-image:url('images/no-data-found.png');">
                      </div>

                      <div class="brandlogo" v-if="product.brand.length != 0 && product.brand.image_path != null"
                           v-bind:style="{ backgroundImage: 'url(' + product.brand.image_base_path+product.brand.image_path + ')' }"></div>
                      <div class="brandlogo-noimage" v-else style="background-image:url('images/nologo.png');"></div>
                    </b-link>

                    <b-link
                        :to="makeBreadcrumbLink(product)"
                        class="product-info">
                      <h3 class="mb-2">{{ product.name }}</h3>
                      <!-- <h3 class="mb-2" v-else>{{ product.name.substring(0,30)+".." }}</h3> -->

                      <div class="d-flex align-items-center pt-2 pb-2">
                                                <span v-for="tyreSeason in tyreSeasons" :key="tyreSeason.id">
                                                    <i v-if="tyreSeason.id == product.tyre_season_id && tyreSeason.name == 'Summer'"
                                                       class="icon-summer mr-1"></i>
                                                    <i v-if="tyreSeason.id == product.tyre_season_id && tyreSeason.name == 'Winter Friction'"
                                                       class="icon-winter mr-1"></i>
                                                    <i v-if="tyreSeason.id == product.tyre_season_id && tyreSeason.name == 'Winter Studded'"
                                                       class="icon-winter mr-1"></i>
                                                    <i v-if="tyreSeason.id == product.tyre_season_id && tyreSeason.name == 'Winter Studdable'"
                                                       class="icon-winter mr-1"></i>
                                                    <i v-if="tyreSeason.id == product.tyre_season_id && tyreSeason.name == 'All Season'"
                                                       class="icon-allseason mr-1"></i>
                                                
                                                    <label class="mb-0 text-dark"
                                                           v-if="tyreSeason.id == product.tyre_season_id">{{
                                                        $t(tyreSeason.name)
                                                      }}</label>
                                                </span>
                      </div>
                      <ul class="eulabels pt-2 pb-2">
                        <li><span class="eulabels-tag fuel-tag" :class="`level-`+product.fuel_effiency"><i
                            class="fas fa-gas-pump"></i> {{ product.fuel_effiency }}</span></li>
                        <li><span class="eulabels-tag wet-tag" :class="`level-`+product.wet_grip"><i
                            class="fas fa-cloud-showers-heavy"></i> {{ product.wet_grip }}</span></li>
                        <li>
                                                    <span class="eulabels-tag noice-tag">
                                                        <i class="fas">
                                                            <img v-if="product.noice_value < 69"
                                                                 src="../../public/images/volumeicon/vol1.png"/>
                                                            <img
                                                                v-else-if="product.noice_value >= 69 && product.noice_value < 73"
                                                                src="../../public/images/volumeicon/vol2.png"/>
                                                            <img v-else src="../../public/images/volumeicon/vol3.png"/>
                                                        </i> 
                                                        {{ product.noice_value }}
                                                    </span>
                        </li>
                      </ul>

                      <!-- <p class="mb-2"><img src="/images/tyre-icon-1.jpg">{{product.fuel_effiency}}</p>
                      <p class="mb-2"><img src="/images/tyre-icon-2.jpg">{{product.wet_grip}}</p>
                      <p class="mb-3"><img src="/images/tyre-icon-3.jpg">{{product.noice_value}}</p> -->
                      <p class="price pt-4 font-weight-bold"><span
                          v-html="setCurrency(product.net_price_with_rc)"></span></p>
                      <p class="pb-3 rc-block rc-label" v-if="product.is_recycled == '0'"><img class="rc-icon"
                                                                                               src="../../public/images/recycling_icon.png"/><span
                          class="rc-label-span">{{ $t('Recycling fee included') }}</span></p>
                      <p v-if="product.available_quantity >= 4" class="text-success text-right font-weight-bold">
                        {{ $t('In stock') }}</p>
                      <p v-else class="text-danger text-right font-weight-bold">{{ $t('Available qty:') }}
                        {{ product.available_quantity }}</p>

                    </b-link>
                    <div class="product-control pt-3 pb-3">
                      <button
                          @click="addProductToCart({
                                                    'type_id':product.id,
                                                    'id':product.id,
                                                    'name':product.name,
                                                    'image':product.image?product.image.image_base_path+product.image.path:'/images/no-data-found.png',
                                                    'brand_image': (product.brand.length != 0 && product.brand.image_path != null)?product.brand.image_base_path+product.brand.image_path:'/images/nologo.png',
                                                    'net_price': product.net_price,
                                                    'qty': 4,
                                                    'available_quantity': product.available_quantity,
                                                    'in_stock': product.in_stock,
                                                    'car_type': product.car_type,
                                                    // 'model': product.model.name,
                                                    'brand_name': product.brand.name,
                                                    'main_product' : product
                                                })"
                          class="btn btn-add-cart rounded-5 text-center bg-green color-white">
                        <i class="fa fa-shopping-cart"></i>
                        {{ $t('Add to cart') }}
                      </button>
                      <router-link
                          class="btn view-details text-center rounded-5 bg-yellow color-white"
                          :to="makeBreadcrumbLink(product)">
                        <!--tyre/{{product.car_type}}/{{product.season}}/{{product.width}}-{{product.aspect_ratio}}-r{{product.diameter}}/{{product.brand.slug}}/{{product.model.slug}}-->
                        {{ $t('View Details') }}
                      </router-link>
                      <!--<router-link
                          class="btn view-details text-center rounded-5 bg-yellow color-white"
                          :to="{ name: 'product-details', params: {brand: product.brand.name, productName: normalizeString(product.name), productid: product.id } }">
                          <i class="fa fa-eye"></i>
                          {{ $t('View Details') }}
                      </router-link>-->
                    </div>
                  </div>
                </div>

                <br>

                <div class="col-md-12 col-lg-12" v-if="totalProducts != 0 && totalProducts > pageSize">
                  <b-pagination
                      pills
                      v-model="currentPage"
                      :total-rows="totalProducts"
                      :per-page="pageSize"></b-pagination>
                </div>

              </div>
            </div>
          </div>
        </div>
        <b-modal id="modal-1">
          <template #modal-header>
            <h5 class="modal-title color-black font-italic">
              {{ selectedServicePoint !== null ? $t('Change') : $t('Select') }} {{ $t('Service Point') }}
            </h5>
            <button type="button" @click="$bvModal.hide('modal-1')" aria-label="Close" class="close">×</button>
          </template>
          <div class="container py-3">

            <div class="sp-search-form form-inline">
              <div class="sp-group-item-767">
                <div class="form-group sp-form-item sp-margin-top-mdsm-2 sp-w-50">
                  <label for="sp_vehicle_type">{{ $t("Select vehicle type") }}</label>
                  <b-form-select
                      id="sp_vehicle_type"
                      class=""
                      :options="currentLang === 'fi_FI' ? vehicle_types_fi : vehicle_types"
                      v-model="default_v_t"
                      @change="searchServicePoints()"
                  ></b-form-select>
                </div>
                <div class="form-group d-max-767 sp-form-item sp-margin-top-mdsm-2 sp-w-50">
                  <label for="sp_maximum_distance">{{ $t("Distance") }}</label>
                  <b-form-select
                      id="sp_maximum_distance"
                      class=""
                      :options="currentLang === 'fi_FI' ? kilometerRange_fi : kilometerRange"
                      v-model="defaultKilometer"
                      @change="searchServicePoints()"
                  ></b-form-select>
                </div>
              </div>

              <div class="form-group sp-form-item flex-grow-1 mr-2">
                <label>{{ $t("Type your city or post code") }}</label>
                <vue-google-autocomplete
                    id="map"
                    classname="form-control google-input-box w-100"
                    :class="addressError"
                    :placeholder="$t('Type your city or post code')"
                    v-on:placechanged="getAddressData"
                    :country="['fi']"
                    v-model="address"
                    required="true"
                    types="geocode"
                    ref="autocomplete"
                >
                </vue-google-autocomplete>
              </div>
              <div class="form-group sp-form-item mr-2 sp-margin-top-mdsm-2 d-none-767">
                <label for="sp_maximum_distance">{{ $t("Distance") }}</label>
                <b-form-select
                    id="sp_maximum_distance"
                    class=""
                    :options="currentLang === 'fi_FI' ? kilometerRange_fi : kilometerRange"
                    v-model="defaultKilometer"
                    @change="searchServicePoints()"
                ></b-form-select>
              </div>
              <div class="form-group sp-form-item">
                <button
                    v-if="address !== ''"
                    type="button"
                    @click="clearSearchedServicePoint()"
                    class="btn bg-yellow text-uppercase font-weight-bold">
                  {{ $t('Clear') }}
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div v-if="service_points.length > 0"
                     class="hm-single-dealer-container d-flex align-items-start justify-content-between p-3 border-bottom flex-wrap flex-sm-wrap">
                  <div class="service-point-column font-weight-bold">
                            <span class="float-right cursor-pointer" id="popover-target-sorting-content">
                                <span class="font-12">
                                  {{ getSortingTitle }}
                                  <i v-if="defaultSort === 0" class="fa fa-sort-numeric-asc" aria-hidden="true"></i>
                                  <i v-if="defaultSort === 1" class="fa fa-sort-numeric-desc" aria-hidden="true"></i>
                                  <i v-if="defaultSort === 2" class="fa fa-sort-alpha-asc" aria-hidden="true"></i>
                                  <i v-if="defaultSort === 3" class="fa fa-sort-alpha-desc" aria-hidden="true"></i>
                                </span>
                              </span>
                    <p class="font-16 mb-0 font-weight-light">
                      {{
                        ($t('service_point_title_tagline')).replace('{kilometer}', defaultKilometer).replace('{city}', address).replace('{service_point_count}', (service_points.length || 0))
                      }}
                    </p>
                    <b-popover target="popover-target-sorting-content" triggers="hover" placement="bottom">
                      <b-form-select :options="currentLang === 'fi_FI' ? sortingOptions_fi :  sortingOptions"
                                     v-model="defaultSort" @change="sortSearchedServicePoints()"></b-form-select>
                    </b-popover>
                  </div>
                  <div class="service-column font-weight-bold px-3 d-none-767">
                    <p class="font-16 mb-0 font-weight-light">{{ $t('Installation price per tyre') }} </p>
                  </div>
                  <div class="next-available-time-column font-weight-bold px-3 d-min-992">
                    <p class="font-16 mb-0 font-weight-light">{{ $t("Next available time") }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="w-100 d-flex p-2 justify-content-center border-dark" v-if="servicepointloading">
                  <span class="fa fa-spinner fa-spin"></span>
                </div>

                <div class="w-100 service-point-list-container"
                     v-if="showServices && service_points.length && !servicepointloading">
                  <div v-for="(service_point, service_point_index) in service_points" :key="service_point_index"
                       class="hm-single-dealer-container border mb-3"
                       :class="{'active' : (selectedServicePoint != null && service_point.id == selectedServicePoint.id)}"
                       @click.stop="selectAndRemoveServicePoint(service_point)"
                  >
                    <div
                        class="d-flex align-items-start justify-content-between px-3 pt-3 pb-lg-3 flex-wrap flex-sm-wrap">
                      <div class="service-point-column">
                        <ul class="service-point-details font-14-991">
                          <li class="online-icon d-max-767" v-if="service_point.time_slots.length">
                            {{ $t('Online appointment available') }}
                          </li>
                          <li class="phone-icon d-max-767" v-else>
                            {{ $t('Appointment by phone') }} :
                            <p class="pl-1">{{ $t('tel') }}. {{ service_point.contact_number }}</p>
                          </li>
                          <li class="organization-name">
                            {{ service_point.company_name }}
                            <span class="float-right cursor-pointer mr-2"
                                  :id="`service_point_info_${service_point.id}`"><i class="info-icon"></i></span>
                            <popover-service-point-right :service_point="service_point"></popover-service-point-right>
                          </li>
                          <li class="distance-icon d-flex align-items-center">
                            <span class="font-italic km-container">{{
                                parseFloat(service_point.distance_km).toFixed(2)
                              }} {{ $t('km') }}</span>
                            <div class="sp-logo-container" v-if="service_point.profile_image_path !== null"><img
                                :src="`${service_point.image_base_path}${service_point.profile_image_path}`"
                                class="sp-logo"></div>
                          </li>
                          <li class="address-icon">{{ service_point.address_line_1 }}
                            {{ service_point.address_line_2 !== 'null' ? service_point.address_line_2 : '' }}
                          </li>
                          <li class="opening-hour-icons" v-if="Object.entries(service_point.time_slots).length"
                              :id="`opening_hour_${service_point.id}`">
                            {{ $t('Opening hours') }}
                            <HomepageOpeningHourPopover :service_point="service_point"/>
                          </li>
                          <li class="address-last">
                            {{ !((service_point.address_line_1).toLowerCase().includes(service_point.zipcode.toLowerCase()) && service_point.address_line_1 !== null && service_point.address_line_1.toLowerCase().includes(service_point.zipcode.toLowerCase())) ? (service_point.zipcode + ',') : '' }}
                            {{ !(service_point.address_line_1.toLowerCase().includes(service_point.city.toLowerCase()) && service_point.address_line_1 !== null && service_point.address_line_1.toLowerCase().includes(service_point.city.toLowerCase())) ? service_point.city : '' }}
                          </li>
                          <li class="time-icon d-max-991" v-if="service_point.time_slots.length">
                            {{ nextAvailableSlotDateCommon(service_point) }}
                            <span class="cursor-pointer" v-b-modal="'my-modal-'+service_point.dealer_id"
                                  @click="showModal = true"><i class="info-icon"
                                                               :id="'nat_responsive-'+service_point.dealer_id"></i></span>
                            <b-popover :target="'nat_responsive-'+service_point.dealer_id" triggers="hover"
                                       placement="top" :custom-class="'custom-popover-nat-info'">
                              {{ $t("Click here to show the available timeslots") }}
                            </b-popover>
                          </li>
                        </ul>
                        <div class="d-max-767 d-service-block-max-767">
                          <HomeViewAttachedService :service_point="service_point" id_prefix="d_max_767"
                                                   :display_service_limit="2"></HomeViewAttachedService>
                        </div>
                      </div>
                      <div class="service-column px-3 d-none-767">
                        <HomeViewAttachedService :service_point="service_point" id_prefix="d_min_767"
                                                 :display_service_limit="3"></HomeViewAttachedService>
                        <ul class="service-point-details font-14-991" v-if="service_point.time_slots.length">
                          <li class="online-icon d-max-991">{{ $t('Online appointment available') }}</li>
                        </ul>
                      </div>
                      <div class="next-available-time-column px-3 d-min-992">
                        <ul class="service-point-details">
                          <li class="time-icon" v-if="service_point.time_slots.length">
                            {{ nextAvailableSlotDateCommon(service_point) }}
                            <span class="cursor-pointer" v-b-modal="'my-modal-'+service_point.dealer_id"
                                  @click="showModal = true"><i class="info-icon"
                                                               :id="'nat-'+service_point.dealer_id"></i></span>
                            <b-popover :target="'nat-'+service_point.dealer_id" triggers="hover" placement="top"
                                       :custom-class="'custom-popover-nat-info'">
                              {{ $t("Click here to show the available timeslots") }}
                            </b-popover>
                          </li>
                          <li class="online-icon" v-if="service_point.time_slots.length">
                            {{ $t('Online appointment available') }}
                          </li>
                          <li class="phone-icon" v-else>
                            {{ $t('Appointment by phone') }} :
                            <p class="pl-1">{{ $t('tel') }}. {{ service_point.contact_number }}</p>
                          </li>
                        </ul>
                        <div class="pt-2" v-if="!1">
                          <button
                              class="text-uppercase pt-2 pb-2 pl-3 rounded pr-3 bg-dark color-white call-appointment-btn">
                            <i class="fa fa-phone"></i> {{ $t("Appointment") }}
                          </button>
                        </div>
                        <div class="pt-2">
                          <button @click.stop="startSearchOnNewServicePoint(service_point)"
                                  class="text-uppercase pt-2 pb-2 pl-3 rounded pr-3 bg-success color-white appointment-btn">
                            <i class="fa fa-search"></i> {{ $t("Search Tyres") }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="d-max-991">
                      <div
                          class="d-flex align-content-center justify-content-end appointment-search-btn-container py-2">
                        <div class="w-50-appointment-btn" v-if="!1">
                          <button
                              class="text-uppercase pt-2 pb-2 pl-3 rounded pr-3 btn-block bg-dark color-white call-appointment-btn">
                            <i class="fa fa-phone"></i> {{ $t("Appointment") }}
                          </button>
                        </div>
                        <div class="w-50-search-btn">
                          <button @click.stop="startSearchOnNewServicePoint(service_point)"
                                  class="text-uppercase bg-success btn-sm-block pt-2 pb-2 pl-3 rounded pr-3 color-white appointment-btn btn-block">
                            <i class="fa fa-search"></i> {{ $t("Search Tyres") }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <b-modal class="modal" :hide-footer="true" title-tag='h4' header-text-variant='dark'
                             title-class="text-uppercase" name="modal" v-if="showModal"
                             :id="'my-modal-'+service_point.dealer_id">
                      <template #modal-header="{ close }">
                        <div>
                          <h4 class="text-uppercase">{{ $t('Available time') }}</h4>
                          <p class="mb-0">{{ $t("available_time_tagline") }}</p>
                        </div>
                        <button type="button" aria-label="Close" class="close text-dark" @click="close()">×</button>
                      </template>
                      <div v-if="service_point">
                        <appointment-popup @goToError="goToError" @hidepopup="removeAppointmentPopup" :allowedTimes="[]"
                                           :dealerService="service_point"
                                           :availableDays="availableSlotDayCommon(service_point)"
                                           :localDealersList="service_points"
                                           :showProceedButton="false"></appointment-popup>
                      </div>
                    </b-modal>
                  </div>
                </div>
                <div class="w-100" v-if="service_points.length == 0 && !servicepointloading">
                  <p class="mb-0"><i class="fa fa-info-circle"></i>
                    {{ $t('Please search nearby area to view service points') }}</p>
                </div>

                <div class="mt-3" v-if="showServices && service_points.length == 0 && !servicepointloading">
                  <p class="text-danger">{{
                      $t("It seems there is no service point available for the selected location. Kindly contact us on Chat or customer service 0405529803 for further assistance.")
                    }}</p>
                </div>
              </div>
            </div>
          </div>

          <template #modal-footer>
            <div class="w-100">
              <b-button
                  v-if="service_points.length"
                  variant="primary"
                  class="float-right"
                  @click="startSearchOnNewServicePoint(selectedServicePoint)"
              >
                {{ $t('Okay') }}
              </b-button>
            </div>
          </template>

        </b-modal>

        <b-modal id="got_to_checkout_popup" centered size="lg" hide-footer hide-header>
          <b-button class="closeicon" @click="$bvModal.hide('got_to_checkout_popup')"><i class="fas fa-times"></i>
          </b-button>
          <checkout-or-stay-popup></checkout-or-stay-popup>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import Vue from 'vue'
import ApiService from '../services/api.service';
import VueSlider from 'vue-slider-component'
import HomeViewAttachedService from "../components/HomeViewAttachedService";
import CheckoutOrStayPopup from "../components/CheckoutOrStayPopup.vue";

import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)
/**https://nightcatsama.github.io/vue-slider-component/ */

// Vue.use(ScrollLoader)

import {BPagination} from 'bootstrap-vue';
import HashMake from '../services/hash.service';

Vue.component('b-pagination', BPagination);

import VueGoogleAutocomplete from 'vue-google-autocomplete'
import HomepageOpeningHourPopover from "../components/HomepageOpeningHourPopover.vue";
import AppointmentPopup from "../components/AppointmentPopup.vue";
import PopoverServicePointRight from "../components/PopoverServicePointRight.vue";

export default {
  name: "product-list",
  metaInfo() {
    return {
      title: 'Product List For ' + this.vehicleType,
      meta: [
        {charset: 'utf-8'},
        {name: 'title', content: this.vehicleType + ' List Page'},
        {name: 'description', content: 'Renkaatalle list page for ' + this.vehicleType},
        {name: 'keywords', content: this.vehicleType + ', renkaatalle, Renkaatalle.fi'},
        {name: 'robots', content: 'index,follow'}
      ],
      link: [
        {rel: 'canonical', href: process.env.VUE_APP_BASE_URL + 'Car'},
        {rel: 'canonical', href: process.env.VUE_APP_BASE_URL + 'Light Truck'}
      ]
    }
  },
  data() {
    return {
      superadminUrl: "",
      currentPage: 1,
      pageSize: 20,
      vehicleType: 'All',
      licencePlateSearch: {
        licencePlate: ''
      },
      searchBySize: {
        width: null,
        height: null,
        diameter: null,
        tyreSeason: null,
        speedIndex: null
      },
      priceRangesMin: 0,
      priceRangesMax: 0,
      selectedPriceRanges: [0, 0],
      products: [],
      selectedBrands: this.$route.query.brand ? (!Array.isArray(this.$route.query.brand) ? [this.$route.query.brand] : this.$route.query.brand) : [],
      selectedTyreSeasons: this.$route.query.tyre_season ? (!Array.isArray(this.$route.query.tyre_season) ? [this.$route.query.tyre_season] : this.$route.query.tyre_season) : [],
      selectedFuelEfficiencies: this.$route.query.fuel_efficiency ? (!Array.isArray(this.$route.query.fuel_efficiency) ? [this.$route.query.fuel_efficiency] : this.$route.query.fuel_efficiency) : [],
      selectedWetGrips: this.$route.query.wet_grip ? (!Array.isArray(this.$route.query.wet_grip) ? [this.$route.query.wet_grip] : this.$route.query.wet_grip) : [],
      selectedNoiseClasses: this.$route.query.noise_class ? (!Array.isArray(this.$route.query.noise_class) ? [this.$route.query.noise_class] : this.$route.query.noise_class) : [],
      selectedNoiseValues: this.$route.query.noise_value ? (!Array.isArray(this.$route.query.noise_value) ? [this.$route.query.noise_value] : this.$route.query.noise_value) : [],
      selectedSpeedIndexes: this.$route.query.speed_index ? (!Array.isArray(this.$route.query.speed_index) ? [this.$route.query.speed_index] : this.$route.query.speed_index) : [],
      selectedLoadIndexes: this.$route.query.load_index ? (!Array.isArray(this.$route.query.load_index) ? [this.$route.query.load_index] : this.$route.query.load_index) : [],
      loadMore: false,
      page: 1,
      totalProducts: 0,
      totalPage: 0,
      images: [],
      masks: [],
      selectedSort: 'net_price',
      selectedSortDir: 'asc',
      selected: {Name: 'net_price', order: 'Asc'},
      optionSorting: [
        {value: {Name: 'name', order: 'Asc'}, text: 'Name: A-Z'},
        {value: {Name: 'name', order: 'Desc'}, text: 'Name : Z-A'},
        {value: {Name: 'net_price', order: 'Asc'}, text: 'Price : Low to high'},
        {value: {Name: 'net_price', order: 'Desc'}, text: 'Price : High to low'},
      ],
      noDataFoundStatus: false,
      cartNo: (this.cartId) ? this.cartId : null,
      enableCross: false,
      moneySign: "€",
      min: -50,
      max: 90,
      slider: 40,
      range: [-20, 70],
      value: [30, 70],
      tooltip: {isVisible: true},
      limits: {enabled: true, minStart: 10, minEnd: 40, maxStart: 60, maxEnd: 90},
      type: "Range",
      minPrice: "500",
      maxPrice: "50000",
      minValue: "25000",
      loading: false,
      showSuccessAlert: 0,
      maxAvailableQuantity: 0,
      isActive: true,
      resetEnabled: false,
      addressError: '',
      address: '',
      showServices: false,
      servicepointloading: false,
      kilometerRange: [
        {text: 'All', value: 100},
        {text: '10 km', value: 10},
        {text: '20 km', value: 20},
        {text: '30 km', value: 30},
        {text: '50 km', value: 50}
      ],
      kilometerRange_fi: [
        {text: 'Kaikki', value: 100},
        {text: '10 km', value: 10},
        {text: '20 km', value: 20},
        {text: '30 km', value: 30},
        {text: '50 km', value: 50}
      ],
      vehicle_types: [{text: "All", value: 1}, {text: "Car", value: 2}, {text: "Van", value: 3}],
      vehicle_types_fi: [{text: "Kaikki", value: 1}, {text: "Henkilöauto", value: 2}, {text: "Pakettiauto", value: 3}],
      defaultKilometer: 100,
      default_v_t: 1,
      defaultSort: 0,
      sortingTitles: ["From nearest", "From farthest", "Name A -Ö", "Name Ö-A"],
      sortingTitles_fi: ["Lähimmästä", "Kauvimmasta", "Nimi A-Ö", "Nimi Ö-A"],
      sortingOptions: [
        {text: "From nearest", value: 0},
        {text: "From farthest", value: 1},
        {text: "Name A -Ö", value: 2},
        {text: "Name Ö-A", value: 3},
      ],
      sortingOptions_fi: [
        {text: "Lähimmästä", value: 0},
        {text: "Kauvimmasta", value: 1},
        {text: "Nimi A-Ö", value: 2},
        {text: "Nimi Ö-A", value: 3},
      ],
      showModal: false,
      allSelectedBrands: false,
      indeterminateBrands: false,
      allSelectedSpeedIndexes: false,
      indeterminateSpeedIndexes: false,
      allSelectedLoadIndexes: false,
      indeterminateLoadIndexes: false,
      allSelectedFuelEfficiencies: false,
      indeterminateFuelEfficiencies: false,
      allSelectedWetGrips: false,
      indeterminateWetGrips: false,
      allSelectedTyreSeasons: false,
      indeterminateTyreSeasons: false,
      allSelectedNoiseClasses: false,
      indeterminateNoiseClasses: false,
      allSelectedNoiseValues: false,
      indeterminateNoiseValues: false
    }
  },
  computed: {
    ...mapGetters('app', ['currentLang']),
    ...mapGetters('search', [
      'vehicleTypes', 'tyreSeasons', 'widths', 'heights', 'diameters', 'speedIndexes', 'loadIndexes', 'activeVehicleTypes', // 'products',
      'searchProductDet', 'brands', 'priceRanges', 'categories', 'fuelEfficiencies', 'wetGrips', 'noiseClasses', 'noiseValues', 'activeWidth', 'activeHeight',
      'activeDiameter', 'activeSpeedIndex', 'activeTyreSeason', 'activeLicencePlate', 'selectedPriceRange', 'filSpeedIndexes', 'filLoadIndexes', 'filBrands', 'filPriceRanges',
      'filCategories', 'filFuelEfficiencies', 'filWetGrips', 'filNoiseClasses', 'filNoiseValues', 'filTyreSeasons', 'allTyreSeasons', 'searchStatus', 'vts']),
    ...mapGetters('cart', ['cartId', 'cartProducts']),
    ...mapGetters("search_dealer", ['service_points', 'selectedServicePoint', 'tyre_category']),
    ...mapGetters('appointments', ['holidays']),
    getSortingTitle() {
      return this.currentLang == "fi_FI" ? this.sortingTitles_fi[this.defaultSort] : this.sortingTitles[this.defaultSort]
    },
    is_tyre_link() {
      return ((this.vehicleTypes && this.vehicleTypes.length > 1) && ((this.tyre_category && this.tyre_category.id > 1) || (this.$route.query.width && this.$route.query.height && this.$route.query.diameter) || this.selectedTyreSeasons.length || this.selectedBrands.length || this.selectedFuelEfficiencies.length || this.selectedWetGrips.length || this.selectedNoiseClasses.length || this.selectedNoiseValues.length || this.selectedSpeedIndexes.length || this.selectedLoadIndexes.length))
    },
    is_tyre_category_link() {
      return ((this.$route.query.width && this.$route.query.height && this.$route.query.diameter) || this.selectedTyreSeasons.length || this.selectedBrands.length || this.selectedFuelEfficiencies.length || this.selectedWetGrips.length || this.selectedNoiseClasses.length || this.selectedNoiseValues.length || this.selectedSpeedIndexes.length || this.selectedLoadIndexes.length)
    },
    tyre_category_name() {
      return this.tyre_category && this.tyre_category.id ? (this.currentLang === 'en_GB' ? this.tyre_category.name_en : this.tyre_category.name_fi) : '';
    },
    is_tyre_size_link() {
      return ((this.$route.query.width && this.$route.query.height && this.$route.query.diameter) && (this.selectedTyreSeasons.length || this.selectedBrands.length || this.selectedFuelEfficiencies.length || this.selectedWetGrips.length || this.selectedNoiseClasses.length || this.selectedNoiseValues.length || this.selectedSpeedIndexes.length || this.selectedLoadIndexes.length))
    },
    tyres_size_breadcrumb_html() {
        var html = ``;
        if (this.$route.query.width && this.$route.query.height && this.$route.query.diameter) {
          html += `<span>${this.$route.query.width}<b>-</b>${this.$route.query.height}<b>-</b>r${this.$route.query.diameter}</span>`;
        }
      return html
    },
    is_tyre_season_link() {
      return (this.selectedTyreSeasons.length > 1 || this.selectedBrands.length || this.selectedFuelEfficiencies.length || this.selectedWetGrips.length || this.selectedNoiseClasses.length || this.selectedNoiseValues.length || this.selectedSpeedIndexes.length || this.selectedLoadIndexes.length)
    },
    tyres_season_breadcrumb_html() {
      var html = ``;
      var selected_seasons = this.tyreSeasons.filter(season => this.selectedTyreSeasons.indexOf(season.name) !== -1)
        if (selected_seasons.length) {
          html += ` <span class="${this.is_tyre_season_link || selected_seasons.length > 1 ? 'custom-breadcrumb-item make-link' : ''}" data-name="${selected_seasons[0]['name']}">${selected_seasons[0][this.currentLang === 'en_GB' ? 'name' : 'name_fi']}</span> `;
          if (selected_seasons.length > 1) {
            html += `<div class="custom-dropdown"><i class="custom-dropdown-toggle">...</i>`;
            html += `<ul class="custom-dropdown-menu">`;
            for(var i = 1; i < selected_seasons.length; i++) {
              html += `<li class="custom-dropdown-item custom-breadcrumb-item" data-name="${selected_seasons[i]['name']}">${selected_seasons[i][this.currentLang === 'en_GB' ? 'name' : 'name_fi']}</li>`;
            }
            html += `</ul></div>`;
          }

          html += this.is_tyre_season_link ? `<i class="fa fa-angle-right mx-1"></i>` : ``;
        }
      return html
    },
    is_tyre_brand_link() {
      return (this.selectedBrands.length > 1 || this.selectedFuelEfficiencies.length || this.selectedWetGrips.length || this.selectedNoiseClasses.length || this.selectedNoiseValues.length || this.selectedSpeedIndexes.length || this.selectedLoadIndexes.length)
    },
    tyres_brand_breadcrumb_html() {
      var html = ``;
      var selected_brands = this.brands.filter(brand => this.selectedBrands.indexOf(brand.name) !== -1)
      if (selected_brands.length) {
        html += ` <span class="${this.is_tyre_brand_link || selected_brands.length > 1 ? 'custom-breadcrumb-item make-link' : ''}"> ${selected_brands[0]['name']} </span>`;
        if (selected_brands.length > 1) {
          html += `<div class="custom-dropdown"><i class="custom-dropdown-toggle">...</i>`;
          html += `<ul class="custom-dropdown-menu">`;
          for(var i = 1; i < selected_brands.length; i++) {
            html += `<li class="custom-dropdown-item custom-breadcrumb-item" data-name="${selected_brands[i]['name']}" data-brand-name="${selected_brands[i]['name']}">${selected_brands[i]['name']}</li>`;
          }
          html += `</ul></div>`;
        }
        html += this.is_tyre_brand_link ? `<i class="fa fa-angle-right mx-1"></i>` : ``;
      }
      return html
    },
    is_speed_index_link() {
      return (this.selectedSpeedIndexes.length  > 1 || this.selectedFuelEfficiencies.length || this.selectedWetGrips.length || this.selectedNoiseClasses.length || this.selectedNoiseValues.length || this.selectedLoadIndexes.length)
    },
    tyre_speed_index_breadcrumb_html() {
      var html = ``;
      var selected_speed_indexes = this.speedIndexes.filter(speedIndex => this.selectedSpeedIndexes.indexOf(speedIndex.speed_index) !== -1)
      if (selected_speed_indexes.length) {
        html += ` <span class="${this.is_speed_index_link ||selected_speed_indexes.length > 1 ? 'custom-breadcrumb-item make-link' : ''}" data-name="${selected_speed_indexes[0]['speed_index']}"> ${selected_speed_indexes[0]['speed_index']} </span>`;
        if (selected_speed_indexes.length > 1) {
          html += `<div class="custom-dropdown"><i class="custom-dropdown-toggle">...</i>`;
          html += `<ul class="custom-dropdown-menu">`;
          for(var i = 1; i < selected_speed_indexes.length; i++) {
            html += `<li class="custom-dropdown-item custom-breadcrumb-item" data-name="${selected_speed_indexes[i]['speed_index']}">${selected_speed_indexes[i]['speed_index']}</li>`;
          }
          html += `</ul></div>`;
        }
        html += this.is_speed_index_link ? `<i class="fa fa-angle-right mx-1"></i>` : ``;
      }
      return html
    },
    is_fuel_efficiency_link() {
      return (this.selectedFuelEfficiencies.length > 1 || this.selectedWetGrips.length || this.selectedNoiseClasses.length || this.selectedNoiseValues.length || this.selectedLoadIndexes.length)
    },
    tyre_fuel_efficiencies_breadcrumb_html() {
      var html = ``;
      var selected_fuel_efficiencies = this.fuelEfficiencies.filter(fuelEfficiency => this.selectedFuelEfficiencies.indexOf(fuelEfficiency.fuel_efficiency) !== -1)
      if (selected_fuel_efficiencies.length) {
        html += ` <span class="${this.is_fuel_efficiency_link || selected_fuel_efficiencies.length > 1 ? 'custom-breadcrumb-item make-link' : ''}" data-name="${selected_fuel_efficiencies[0]['fuel_efficiency']}"> ${selected_fuel_efficiencies[0]['fuel_efficiency']} </span>`;
        if (selected_fuel_efficiencies.length > 1) {
          html += `<div class="custom-dropdown"><i class="custom-dropdown-toggle">...</i>`;
          html += `<ul class="custom-dropdown-menu">`;
          for(var i = 1; i < selected_fuel_efficiencies.length; i++) {
            html += `<li class="custom-dropdown-item custom-breadcrumb-item" data-name="${selected_fuel_efficiencies[i]['fuel_efficiency']}">${selected_fuel_efficiencies[i]['fuel_efficiency']}</li>`;
          }
          html += `</ul></div>`;
        }
        html += this.is_fuel_efficiency_link ? `<i class="fa fa-angle-right mx-1"></i>` : ``;
      }
      return html
    },
    is_wet_grip_link() {
      return (this.selectedWetGrips.length > 1 || this.selectedNoiseClasses.length || this.selectedNoiseValues.length || this.selectedLoadIndexes.length)
    },
    tyre_wet_grips_breadcrumb_html() {
      var html = ``;
      var selected_wet_grips = this.wetGrips.filter(wetGrip => this.selectedWetGrips.indexOf(wetGrip.wet_grip) !== -1)
      if (selected_wet_grips.length) {
        html += ` <span class="${this.is_wet_grip_link || selected_wet_grips.length > 1 ? 'custom-breadcrumb-item make-link' : ''}" data-name="${selected_wet_grips[0]['wet_grip']}"> ${selected_wet_grips[0]['wet_grip']} </span>`;
        if (selected_wet_grips.length > 1) {
          html += `<div class="custom-dropdown"><i class="custom-dropdown-toggle">...</i>`;
          html += `<ul class="custom-dropdown-menu">`;
          for(var i = 1; i < selected_wet_grips.length; i++) {
            html += `<li class="custom-dropdown-item custom-breadcrumb-item" data-name="${selected_wet_grips[i]['wet_grip']}">${selected_wet_grips[i]['wet_grip']}</li>`;
          }
          html += `</ul></div>`;
        }
        html += this.is_wet_grip_link ? `<i class="fa fa-angle-right mx-1"></i>` : ``;
      }
      return html
    },
    is_noice_class_link() {
      return (this.selectedNoiseClasses.length > 1 || this.selectedNoiseValues.length || this.selectedLoadIndexes.length)
    },
    tyre_noice_classes_breadcrumb_html() {
      var html = ``;
      var selected_noice_classes = this.noiseClasses.filter(noiseClass => this.selectedNoiseClasses.indexOf(noiseClass.noice_class) !== -1)
      if (selected_noice_classes.length) {
        html += ` <span class="${this.is_noice_class_link || selected_noice_classes.length > 1 ? 'custom-breadcrumb-item make-link' : ''}" data-name="${selected_noice_classes[0]['noice_class']}"> ${selected_noice_classes[0]['noice_class']} </span>`;
        if (selected_noice_classes.length > 1) {
          html += `<div class="custom-dropdown"><i class="custom-dropdown-toggle">...</i>`;
          html += `<ul class="custom-dropdown-menu">`;
          for(var i = 1; i < selected_noice_classes.length; i++) {
            html += `<li class="custom-dropdown-item custom-breadcrumb-item" data-name="${selected_noice_classes[i]['noice_class']}">${selected_noice_classes[i]['noice_class']}</li>`;
          }
          html += `</ul></div>`;
        }
        html += this.is_noice_class_link ? `<i class="fa fa-angle-right mx-1"></i>` : ``;
      }
      return html
    },
    is_noice_value_link() {
      return (this.selectedNoiseValues.length > 1 || this.selectedLoadIndexes.length)
    },
    tyre_noice_values_breadcrumb_html() {
      var html = ``;
      var selected_noice_values = this.noiseValues.filter(noiseClass => this.selectedNoiseValues.includes(noiseClass.noice_value))
      if (selected_noice_values.length) {
        html += ` <span class="${this.is_noice_value_link || selected_noice_values.length > 1 ? 'custom-breadcrumb-item make-link' : ''}" data-name="${selected_noice_values[0]['noice_value']}"> ${selected_noice_values[0]['noice_value']} </span>`;
        if (selected_noice_values.length > 1) {
          html += `<div class="custom-dropdown"><i class="custom-dropdown-toggle">...</i>`;
          html += `<ul class="custom-dropdown-menu">`;
          for(var i = 1; i < selected_noice_values.length; i++) {
            html += `<li class="custom-dropdown-item custom-breadcrumb-item" data-name="${selected_noice_values[i]['noice_value']}">${selected_noice_values[i]['noice_value']}</li>`;
          }
          html += `</ul></div>`;
        }
        html += this.is_noice_value_link ? `<i class="fa fa-angle-right mx-1"></i>` : ``;
      }
      return html
    },
    is_load_index_link() {
      return (this.selectedLoadIndexes.length > 1)
    },
    tyre_load_index_breadcrumb_html() {
      var html = ``;
      var selected_load_indexes = this.loadIndexes.filter(loadIndex => this.selectedLoadIndexes.indexOf(loadIndex.load_index) !== -1)
      if (selected_load_indexes.length) {
        html += ` <span class="${this.is_load_index_link || selected_load_indexes.length > 1 ? 'custom-breadcrumb-item make-link' : ''}" data-name="${selected_load_indexes[0]['load_index']}"> ${selected_load_indexes[0]['load_index']} </span>`;
        if (selected_load_indexes.length > 1) {
          html += `<div class="custom-dropdown"><i class="custom-dropdown-toggle">...</i>`;
          html += `<ul class="custom-dropdown-menu">`;
          for(var i = 1; i < selected_load_indexes.length; i++) {
            html += `<li class="custom-dropdown-item custom-breadcrumb-item" data-name="${selected_load_indexes[i]['load_index']}">${selected_load_indexes[i]['load_index']}</li>`;
          }
          html += `</ul></div>`;
        }
      }
      return html
    }
  },
  async created() {
    if (
        !(this.currentLang === 'en_GB' && this.$route.name === 'product_list_by_vehicle_type') ||
        !(this.currentLang === 'fi_FI' && this.$route.name === 'product_list_by_vehicle_type_fi')
    ) {
      var lang = this.$route.name === 'product_list_by_vehicle_type' ? 'en_GB' : 'fi_FI'
      var lang_label = this.$route.name === 'product_list_by_vehicle_type' ? 'English' : 'Suomi'
      this.$i18n.locale = lang
      this.setLang(lang)
      localStorage.setItem('locale', lang);
      localStorage.setItem('locale_label', lang_label);
    }
    if (this.$route.query.width && this.$route.query.height && this.$route.query.diameter) {
      this.resetEnabled = true
    } else {
      this.resetEnabled = false
    }
    if ("Default_V_T" in localStorage) {
      this.default_v_t = localStorage.getItem("Default_V_T")
    }
    if ("DefaultKilometer" in localStorage) {
      this.defaultKilometer = localStorage.getItem("DefaultKilometer")
    }
    this.moneySign = process.env.VUE_APP_CURRENCY_SIGN
    this.getHolidayList();
    if ("SearchedSelectedServicePoint" in localStorage) {
      this.setSelectedServicePoint(JSON.parse(localStorage.getItem("SearchedSelectedServicePoint")))
    } else {
      this.setSelectedServicePoint(null)
    }
    this.loading = true
    //set tyreseasons from localstorage
    if (this.tyreSeasons.length == 0) {
      if (localStorage.getItem("tyreSeasonsLists")) {
        await this.setTyreSeasons(HashMake.decrypt(localStorage.getItem("tyreSeasonsLists")));
      }
    }

    //set brands from localstorage
    if (this.brands.length == 0) {
      if (localStorage.getItem("brandLists")) {
        await this.setBrandsList(HashMake.decrypt(localStorage.getItem("brandLists")));
      }
    }

    this.superadminUrl = process.env.VUE_APP_SUPERADMIN_URL;

    this.vehicleType = await this.VehicleType();
    var QS = {}
    var selectedServicePoint = localStorage.getItem("SearchedSelectedServicePoint");
    if (selectedServicePoint && this.$route.query.ServicePoint) {
      QS['ServicePoint'] = (JSON.parse(selectedServicePoint)).id;
    }
    await this.fetchVehicleTypes(QS);

    var CarTypeObj = {vehicle_type: this.vehicleType};
    if (selectedServicePoint && this.$route.query.ServicePoint) {
      CarTypeObj['ServicePoint'] = (JSON.parse(selectedServicePoint)).id;
    }

    await this.changeCarTypes(CarTypeObj)
    await this.getDynamicFilters();
    await this.getFilters();
    await this.getTyreCategoryByVehicleType(this.vehicleType)
    var carTypeDet = this.vehicleTypes.filter(p => p.car_type == this.vehicleType)

    if (carTypeDet.length == 0) {
      this.$router.push({name: 'page-not-found-redirect', replace: true})
    }
    await this.fetchProducts();
    this.indeterminateAndSelectedAllApply()
  },
  watch: {
    selectedTyreSeasons(newValue) {
      if (!Array.isArray(newValue)) {
        this.selectedTyreSeasons = [newValue];
      }
      this.modifyQueryAndReplaceURL('tyre_season', this.selectedTyreSeasons)
      this.allSelectedTyreSeasons = (this.selectedTyreSeasons.length > 0 && this.selectedTyreSeasons.length === this.tyreSeasons.length) ? true : false
      this.indeterminateTyreSeasons = (this.selectedTyreSeasons.length > 0 && this.selectedTyreSeasons.length !== this.tyreSeasons.length) ? true : false
    },
    selectedBrands(newValue) {
      if (!Array.isArray(newValue)) {
        this.selectedBrands = [newValue];
      }
      this.modifyQueryAndReplaceURL('brand', this.selectedBrands)
      this.allSelectedBrands = (this.selectedBrands.length > 0 && this.selectedBrands.length === this.brands.length) ? true : false
      this.indeterminateBrands = (this.selectedBrands.length > 0 && this.selectedBrands.length !== this.brands.length) ? true : false
    },
    selectedSpeedIndexes(newValue) {
      if (!Array.isArray(newValue)) {
        this.selectedSpeedIndexes = [newValue];
      }
      this.modifyQueryAndReplaceURL('speed_index', this.selectedSpeedIndexes)
      this.allSelectedSpeedIndexes = (this.selectedSpeedIndexes.length > 0 && this.selectedSpeedIndexes.length === this.speedIndexes.length) ? true : false
      this.indeterminateSpeedIndexes = (this.selectedSpeedIndexes.length > 0 && this.selectedSpeedIndexes.length !== this.speedIndexes.length) ? true : false
    },
    selectedLoadIndexes(newValue) {
      if (!Array.isArray(newValue)) {
        this.selectedLoadIndexes = [newValue];
      }
      this.modifyQueryAndReplaceURL('load_index', this.selectedLoadIndexes)
      this.allSelectedLoadIndexes = (this.selectedLoadIndexes.length > 0 && this.selectedLoadIndexes.length === this.loadIndexes.length) ? true : false
      this.indeterminateLoadIndexes = (this.selectedLoadIndexes.length > 0 && this.selectedLoadIndexes.length !== this.loadIndexes.length) ? true : false
    },
    selectedFuelEfficiencies(newValue) {
      if (!Array.isArray(newValue)) {
        this.selectedFuelEfficiencies = [newValue];
      }
      this.modifyQueryAndReplaceURL('fuel_efficiency', this.selectedFuelEfficiencies)
      this.allSelectedFuelEfficiencies = (this.selectedFuelEfficiencies.length > 0 && this.selectedFuelEfficiencies.length === this.fuelEfficiencies.length) ? true : false
      this.indeterminateFuelEfficiencies = (this.selectedFuelEfficiencies.length > 0 && this.selectedFuelEfficiencies.length !== this.fuelEfficiencies.length) ? true : false
    },
    selectedWetGrips(newValue) {
      if (!Array.isArray(newValue)) {
        this.selectedWetGrips = [newValue];
      }
      this.modifyQueryAndReplaceURL('wet_grip', this.selectedWetGrips)
      this.allSelectedWetGrips = (this.selectedWetGrips.length > 0 && this.selectedWetGrips.length === this.wetGrips.length) ? true : false
      this.indeterminateWetGrips = (this.selectedWetGrips.length > 0 && this.selectedWetGrips.length !== this.wetGrips.length) ? true : false
    },
    selectedNoiseClasses(newValue) {
      if (!Array.isArray(newValue)) {
        this.selectedNoiseClasses = [newValue];
      }
      this.modifyQueryAndReplaceURL('noise_class', this.selectedNoiseClasses)
      this.allSelectedNoiseClasses = (this.selectedNoiseClasses.length > 0 && this.selectedNoiseClasses.length === this.noiseClasses.length) ? true : false
      this.indeterminateNoiseClasses = (this.selectedNoiseClasses.length > 0 && this.selectedNoiseClasses.length !== this.noiseClasses.length) ? true : false
    },
    selectedNoiseValues(newValue) {
      if (!Array.isArray(newValue)) {
        this.selectedNoiseValues = [newValue];
      }
      this.modifyQueryAndReplaceURL('noise_value', this.selectedNoiseValues)
      this.allSelectedNoiseValues = (this.selectedNoiseValues.length > 0 && this.selectedNoiseValues.length === this.noiseValues.length) ? true : false
      this.indeterminateNoiseValues = (this.selectedNoiseValues.length > 0 && this.selectedNoiseValues.length !== this.noiseValues.length) ? true : false
    },
    '$route.params': {
      async handler() {
        this.vehicleType = await this.VehicleType()
      }
    },
    '$route.query': {
      async handler(newValue) {
        if (newValue.width && newValue.height && newValue.diameter) {
          this.resetEnabled = true
        } else {
          this.resetEnabled = false
        }
        var selectedServicePoint = localStorage.getItem("SearchedSelectedServicePoint");
        var CarTypeObj = {vehicle_type: this.vehicleType};
        if (this.checkIsServicePointAvailable() && selectedServicePoint) {
          CarTypeObj['ServicePoint'] = (JSON.parse(selectedServicePoint)).id;
        }

        this.changeCarTypes(CarTypeObj);
        this.products = [];
        this.currentPage = 1;
        await this.getDynamicFilters("route_query");
        await this.fetchProducts("route_query");
        this.indeterminateAndSelectedAllApply()
      }
    },
    'activeVehicleTypes': {
      async handler(newValue) {
        // this.searchBySize.width = null;
        // this.searchBySize.height= null;
        // this.searchBySize.diameter= null;
        // this.searchBySize.tyreSeason= 'all';
        // this.searchBySize.speedIndex= 'all';
        // this.products= [];
        // this.selectedBrands = [];
        // this.selectedTyreSeasons = [];
        // this.selectedFuelEfficiencies= [];
        // this.selectedWetGrips = [];
        // this.selectedNoiseClasses = [];
        // this.selectedNoiseValues= [];
        // this.selectedSpeedIndexes = [];
        // this.selectedLoadIndexes = [];

        this.vehicleType = newValue;

        var getDefaultUrlFilters = this.getUrlFilters();

        await this.fetchWidths({"DynamicFilters": getDefaultUrlFilters});
        await this.fetchHeights({"DynamicFilters": getDefaultUrlFilters, width : this.searchBySize.width});
        await this.fetchDiameters({"DynamicFilters": getDefaultUrlFilters, width : this.searchBySize.width, height : this.searchBySize.height})
      }
    },
    'activeWidth': {
      handler(newValue) {
        this.searchBySize.width = newValue;
      }, immediate: true
    },
    'activeHeight': {
      handler(newValue) {
        this.searchBySize.height = newValue;
      }
    },
    'activeDiameter': {
      handler(newValue) {
        this.searchBySize.diameter = newValue;
      }
    },
    'activeSpeedIndex': {
      handler(newValue) {
        this.searchBySize.speedIndex = newValue;
      }
    },
    'activeTyreSeason': {
      handler(newValue) {
        this.searchBySize.tyreSeason = newValue;
      }
    },
    'activeLicencePlate': {
      handler(newValue) {
        this.licencePlateSearch.licencePlate = newValue;
      }
    },
    /*selectedBrands : {
        async handler(newValue) {
          if(!Array.isArray(newValue)) {
              this.selectedBrands = [newValue];
          }

          this.modifyQueryAndReplaceURL('brand', this.selectedBrands)

          if (newValue.length === 0) {
              this.indeterminateBrands = false
              this.allSelectedBrands = false
          } else if (newValue.length === this.brands.length) {
              this.indeterminateBrands = false
              this.allSelectedBrands = true
          } else {
              this.indeterminateBrands = true
              this.allSelectedBrands = false
          }
        }
    },*/
    /*'selectedPriceRanges': {
        async handler(newValue, oldValue) {

            if (newValue.length != 0) {
                // this.selectedPriceRanges = [parseInt(this.filPriceRanges.min_price), parseInt(this.filPriceRanges.max_price)];

                if (this.selectedPriceRanges[1] != 0 && this.selectedPriceRanges[0] != 0 ) {


                    if ((newValue[0] != parseInt(this.filPriceRanges.min_price)) || (newValue[1] != parseInt(this.filPriceRanges.max_price))) {


                        await this.getDynamicFilters()

                        this.products = [];
                        this.currentPage = 1;

                        await this.fetchProducts("selectedPriceRanges");
                    }
                }
            }
        }
    },*/

    /*'selectedCategories': {
        handler(newValue, oldValue) {
            this.products = [];
            this.currentPage = 1;
            this.changeUrl();
            //this.fetchProducts();

            if (newValue.length === 0) {
                this.indeterminateCategories = false
                this.allSelectedCategories = false
            } else if (newValue.length === this.brands.length) {
                this.indeterminateCategories = false
                this.allSelectedCategories = true
            } else {
                this.indeterminateCategories = true
                this.allSelectedCategories = false
            }
        },
        immediate: true
    },*/
    currentPage(value) {
      this.fetchProducts()

      // this.disable = value > 10

      // if((this.totalProducts <  this.pageSize) && (this.totalPage < value)){
      //     this.disable = true
      // }

      // if((this.totalPage < value)){
      //     this.disable = true
      // }

      this.totalPage < value && (this.loadMore = true)

      //this.loadMore = true
    },
    cartId: {
      immediate: true,
      handler(newValue) {
        this.cartNo = newValue
      }
    },
    filPriceRanges: {
      handler(newValue, oldValue) {

        if ((this.filPriceRanges && newValue.length != 0 && oldValue.length == 0)) {
          var min_price = newValue.min_price;
          var max_price = newValue.max_price;

          min_price = min_price == null ? 0 : min_price;
          max_price = max_price == null ? 0 : max_price;

          this.priceRangesMin = parseInt(min_price);
          this.priceRangesMax = Math.ceil(max_price);
          this.selectedPriceRanges = [parseInt(min_price), Math.ceil(max_price)];
        } else if ((this.filPriceRanges && newValue.length != 0 && oldValue.length != 0)) {

          if (newValue.min_price != oldValue.min_price && newValue.max_price != oldValue.max_price) {
            var min_price = newValue.min_price;
            var max_price = newValue.max_price;
            min_price = min_price == null ? 0 : min_price;
            max_price = max_price == null ? 0 : max_price;

            this.priceRangesMin = parseInt(min_price);
            this.priceRangesMax = Math.ceil(max_price);
            this.selectedPriceRanges = [parseInt(min_price), Math.ceil(max_price)];
          }
        }
      },
    },
    service_points: {
      handler(NewServicePoint) {
        if (NewServicePoint.length && this.$route.query.hasOwnProperty("ServicePoint")) {
          const queryServicePointName = this.$route.query.ServicePoint;
          const selected = NewServicePoint.find((ServicePoint) => {
            return this.normalizeString(ServicePoint.company_name) == queryServicePointName
          })
          if (selected) {
            this.setSelectedServicePoint(selected)
          }
        }
      }
    },
    'currentLang': {
      async handler() {
        this.loading = true
        this.setSelectedServicePoint(null)
        this.setDealers([]);
        await this.getTyreCategoryByVehicleType(this.vehicleType)
        var route_name = this.currentLang === 'en_GB' ? 'product_list_by_vehicle_type' : 'product_list_by_vehicle_type_fi'
        var route_param_vt = this.currentLang === 'en_GB' ? this.tyre_category.slug_en : this.tyre_category.slug_fi
        var queryParams = Object.assign({}, this.$route.query)
        var route = {
          name: route_name,
          query: queryParams,
          replace: true
        }
        if (route_param_vt) {
          route.params = {vehicletype: route_param_vt}
        }
        this.$router.push(route)
        this.searchServicePoints();
      }
    },
    'defaultKilometer': {
      handler(newKilometer) {
        localStorage.setItem("DefaultKilometer", newKilometer)
      }
    },
    'default_v_t': {
      handler(newVehicleType) {
        localStorage.setItem("Default_V_T", newVehicleType)
      }
    }
  },
  mounted() {
    this.searchBySize.width = this.$route.query.width ? this.$route.query.width : null;
    this.searchBySize.height = this.$route.query.height ? this.$route.query.height : null;
    this.searchBySize.diameter = this.$route.query.diameter ? this.$route.query.diameter : null;
    this.searchBySize.tyreSeason = this.$route.query.tyreseason ? this.$route.query.tyreseason : null;
    this.searchBySize.speedIndex = this.$route.query.speedindex ? this.$route.query.speedindex : null;

    if (this.searchBySize.diameter) {
      this.setSearchStatus(true);
    }

    var getDefaultUrlFilters = this.getUrlFilters();
    if (this.searchBySize.width != null) {
      this.fetchHeights({"width": this.searchBySize.width, "DynamicFilters": getDefaultUrlFilters});
    }

    if (this.searchBySize.height != null) {
      this.fetchDiameters({"searchBySize": this.searchBySize, "DynamicFilters": getDefaultUrlFilters});
    }

    this.setAddressManually();

    this.$nextTick(() => {
      const tyre_season_breadcrumb = this.$refs.tyre_season_breadcrumb;
      if (tyre_season_breadcrumb) {
        tyre_season_breadcrumb.addEventListener('click', (event) => {
          const target = event.target;
          if (target.classList.contains('custom-breadcrumb-item')) {
            const tyreSeasonName = target.getAttribute('data-name');
            this.move_to_tyre_season(tyreSeasonName);
          }
        });
      }

      const brand_breadcrumb = this.$refs.brand_breadcrumb;
      if (brand_breadcrumb) {
        brand_breadcrumb.addEventListener('click', (event) => {
          const target = event.target;
          if (target.classList.contains('custom-breadcrumb-item')) {
            const brandName = target.getAttribute('data-name');
            this.move_to_brand(brandName);
          }
        });
      }

      const speed_index_breadcrumb = this.$refs.speed_index_breadcrumb;
      if (speed_index_breadcrumb) {
        speed_index_breadcrumb.addEventListener('click', (event) => {
          const target = event.target;
          if (target.classList.contains('custom-breadcrumb-item')) {
            const speed_index = target.getAttribute('data-name');
            this.move_to_speed_index(speed_index);
          }
        });
      }
      const fuel_efficiency_breadcrumb = this.$refs.fuel_efficiency_breadcrumb;
      if (fuel_efficiency_breadcrumb) {
        fuel_efficiency_breadcrumb.addEventListener('click', (event) => {
          const target = event.target;
          if (target.classList.contains('custom-breadcrumb-item')) {
            const fuel_efficiency = target.getAttribute('data-name');
            this.move_to_fuel_efficiency(fuel_efficiency);
          }
        });
      }
      const fuel_wet_grip_breadcrumb = this.$refs.fuel_wet_grip_breadcrumb;
      if (fuel_wet_grip_breadcrumb) {
        fuel_wet_grip_breadcrumb.addEventListener('click', (event) => {
          const target = event.target;
          if (target.classList.contains('custom-breadcrumb-item')) {
            const wet_grip = target.getAttribute('data-name');
            this.move_to_wet_grip(wet_grip);
          }
        });
      }
      const fuel_noise_class_breadcrumb = this.$refs.fuel_noise_class_breadcrumb;
      if (fuel_noise_class_breadcrumb) {
        fuel_noise_class_breadcrumb.addEventListener('click', (event) => {
          const target = event.target;
          if (target.classList.contains('custom-breadcrumb-item')) {
            const noise_class = target.getAttribute('data-name');
            this.move_to_noise_class(noise_class);
          }
        });
      }
      const fuel_noise_value_breadcrumb = this.$refs.fuel_noise_value_breadcrumb;
      if (fuel_noise_value_breadcrumb) {
        fuel_noise_value_breadcrumb.addEventListener('click', (event) => {
          const target = event.target;
          if (target.classList.contains('custom-breadcrumb-item')) {
            const noise_value = target.getAttribute('data-name');
            this.move_to_noise_value(noise_value);
          }
        });
      }
      const fuel_load_index_breadcrumb = this.$refs.fuel_load_index_breadcrumb;
      if (fuel_load_index_breadcrumb) {
        fuel_load_index_breadcrumb.addEventListener('click', (event) => {
          const target = event.target;
          if (target.classList.contains('custom-breadcrumb-item')) {
            const load_index = target.getAttribute('data-name');
            this.move_to_load_index(load_index);
          }
        });
      }
    });
  },
  destroyed() {
    this.setFilPriceRanges([])
  },
  components: {
    'appointment-popup': AppointmentPopup,
    'HomepageOpeningHourPopover': HomepageOpeningHourPopover,
    'vue-google-autocomplete': VueGoogleAutocomplete,
    'HomeViewAttachedService': HomeViewAttachedService,
    'popover-service-point-right': PopoverServicePointRight,
    'checkout-or-stay-popup': CheckoutOrStayPopup
  },
  methods: {
    ...mapActions("search", [
      "filterProducts",
      "getFilters",
      "getAvailableFilters",
      "fetchWidths",
      "fetchHeights",
      "fetchDiameters",
      "changeCarTypes",
      "changeWidthStore",
      "changeHeightStore",
      "changeDiameterStore",
      "changeSpeedIndexStore",
      "changeTyreSeasonStore",
      "changeLicencePlateStore",
      "setSelectedPrice",
      "fetchVehicleTypes",
      "fetchAllTyreSeasons",
      "setTyreSeasons",
      "fetchAllBrands",
      "setBrandsList",
      "setModelsList",
      "setSearchStatus",
      "setFilPriceRanges",
      "getVTS"
    ]),
    ...mapActions('cart', ['addProduct', 'currentProduct', 'getAllCartProducts']),
    ...mapActions("search_dealer", ["fetchDealers", 'setStrAddressWS', 'setSearchedZipcode', 'setDealers', 'setSelectedServicePoint', 'getTyreCategoryByVehicleType']),
    ...mapActions('appointments', ['getHolidayList']),
    ...mapActions('search_by_service_point', ['setShowServices', 'setAddress', 'setDefaultVT', 'setDefaultKilometer', 'setDefaultSort']),
    ...mapActions("app", ["setLang"]),

    async fetchProducts(from) {

      this.loading = true;
      var strDyn = "";

      // this.disable = false;

      var searchArr = new Object();
      var searchArrFilters = new Object();

      if (this.vehicleType) {
        // searchArr.push({"vehicle_type": this.vehicleType});
        searchArr.vehicle_type = '[' + JSON.stringify(this.vehicleType) + ']';
        searchArrFilters.vehicle_type = '[' + JSON.stringify(this.vehicleType) + ']';

        strDyn = '&vehicle_type=[' + this.vehicleType + ']';
      }

      if (this.searchBySize.width) {

        // searchArr.push({"width": this.searchBySize.width}, {"height":this.searchBySize.height}, {"diameter": this.searchBySize.diameter});

        searchArr.width = '[' + JSON.stringify(this.searchBySize.width) + ']';
        searchArr.height = '[' + JSON.stringify(this.searchBySize.height) + ']';
        searchArr.diameter = '[' + JSON.stringify(this.searchBySize.diameter) + ']';

        searchArrFilters.width = '[' + JSON.stringify(this.searchBySize.width) + ']';
        searchArrFilters.height = '[' + JSON.stringify(this.searchBySize.height) + ']';
        searchArrFilters.diameter = '[' + JSON.stringify(this.searchBySize.diameter) + ']';

        // strDyn = '&width=['+this.searchBySize.width+']&height=['+this.searchBySize.height+']&diameter=['+this.searchBySize.diameter+']&speed_index=["'+this.searchBySize.speedIndex+'"]&tyre_season_id=['+this.searchBySize.tyreSeason+']';
        strDyn += '&width=[' + this.searchBySize.width + ']&height=[' + this.searchBySize.height + ']&diameter=[' + this.searchBySize.diameter + ']';
      } else if (this.$route.query.licenceplate) {
        // searchArr.push({"licencePlate": this.searchBySize.licencePlate});

        searchArr.licencePlate = this.searchBySize.licencePlate;

        searchArrFilters.licencePlate = this.searchBySize.licencePlate;

        strDyn += '&licencePlate=[' + this.searchBySize.licencePlate + ']';
      }

      var bandsList = this.brands;
      if (this.selectedBrands.length != 0 && this.brands.length == 0) {
        // await this.fetchAllBrands();

        bandsList = HashMake.decrypt(localStorage.getItem("brandLists"));
      }
      if (!bandsList) {
        await this.getFilters()
        bandsList = this.brands;
      }
      if (this.selectedBrands.length != 0 && bandsList.length != 0) {
        var selectedBrandsId = [];
        this.selectedBrands.find(function (element) {
          var brandId = bandsList.find(brand => brand.name === element).id;
          selectedBrandsId.push(brandId);
        });
        searchArr.brand_id = '[' + selectedBrandsId + ']';
        searchArrFilters.brand_id = '[' + selectedBrandsId + ']';
        strDyn += '&brand_id=[' + this.selectedBrands + ']';
      }

      if (this.selectedSpeedIndexes.length != 0) {

        searchArr.speed_index = JSON.stringify(this.selectedSpeedIndexes);

        searchArrFilters.speed_index = JSON.stringify(this.selectedSpeedIndexes);

        strDyn += '&speed_index=[' + this.selectedSpeedIndexes + ']';
      } else if (this.searchBySize.speedIndex) {
        searchArr.speed_index = '[' + this.searchBySize.speedIndex + ']';
        searchArrFilters.speed_index = '[' + this.searchBySize.speedIndex + ']';
        strDyn += '&speed_index=[' + this.searchBySize.speedIndex + ']';
      }

      var tyreSeasonsArr = [];

      if (Array.isArray(this.selectedTyreSeasons) && this.selectedTyreSeasons.length != 0) {
        // searchArr.tyre_season_id = '['+JSON.stringify(this.selectedTyreSeasons)+']';
        // searchArrFilters.tyre_season_id = '['+JSON.stringify(this.selectedTyreSeasons)+']';

        tyreSeasonsArr = this.selectedTyreSeasons;

        strDyn += '&tyre_season_id=[' + this.selectedTyreSeasons + ']';
      } else if (this.searchBySize.tyreSeason) {
        // searchArr.tyre_season_id = '['+JSON.stringify(this.searchBySize.tyreSeason)+']';
        // searchArrFilters.TyreSeasons = '['+JSON.stringify(this.searchBySize.tyreSeason)+']';
        tyreSeasonsArr = this.searchBySize.tyreSeason;

        strDyn += '&tyre_season_id=[' + this.searchBySize.tyreSeason + ']';
      }

      if (tyreSeasonsArr.length != 0 && this.tyreSeasons.length == 0) {
        await this.fetchAllTyreSeasons();
        await this.setTyreSeasons(this.allTyreSeasons);
      }

      if (tyreSeasonsArr.length != 0 && this.tyreSeasons.length != 0) {

        var tyreSeasonsList = this.tyreSeasons;
        var selectedTyreSeasonsId = [];

        tyreSeasonsArr.find(function (element) {

          var tyreSeasonId = tyreSeasonsList.find(tyreSeason => tyreSeason.name === element).id;
          selectedTyreSeasonsId.push(tyreSeasonId);
        });

        searchArr.tyre_season_id = '[' + selectedTyreSeasonsId + ']';
        searchArrFilters.tyre_season_id = '[' + selectedTyreSeasonsId + ']';
      }

      if (this.selectedWetGrips.length != 0) {
        searchArr.wet_grip = JSON.stringify(this.selectedWetGrips);
        searchArrFilters.wet_grip = JSON.stringify(this.selectedWetGrips);
        strDyn += '&wet_grip=[' + this.selectedWetGrips + ']';
      }

      if (this.selectedNoiseClasses.length != 0) {
        searchArr.noise_class = JSON.stringify(this.selectedNoiseClasses);
        searchArrFilters.noise_class = JSON.stringify(this.selectedNoiseClasses);
        strDyn += '&noise_class=[' + this.selectedNoiseClasses + ']';
      }

      if (this.selectedNoiseValues.length != 0) {
        searchArr.noise_value = JSON.stringify(this.selectedNoiseValues);
        searchArrFilters.noise_value = JSON.stringify(this.selectedNoiseValues);
        strDyn += '&noise_value=[' + this.selectedNoiseValues + ']';
      }

      if (this.selectedFuelEfficiencies.length != 0) {
        searchArr.fuel_efficiency = JSON.stringify(this.selectedFuelEfficiencies);
        searchArrFilters.fuel_efficiency = JSON.stringify(this.selectedFuelEfficiencies);
        strDyn += '&fuel_efficiency=[' + this.selectedFuelEfficiencies + ']';
      }

      if (this.selectedLoadIndexes.length != 0) {

        searchArr.load_index = JSON.stringify(this.selectedLoadIndexes);

        searchArrFilters.load_index = JSON.stringify(this.selectedLoadIndexes);

        strDyn += '&load_index=[' + this.selectedLoadIndexes + ']';
      }

      if (from == "price_ranges") {
        if (this.selectedPriceRanges.length != 0) {
          if (this.selectedPriceRanges[1] != 0 && this.selectedPriceRanges[0] != 0) {
            searchArr.price_lte = parseInt(this.selectedPriceRanges[1]);
            searchArr.price_gte = parseInt(this.selectedPriceRanges[0]);
            // strDyn += '&prices=['+this.selectedPriceRanges+']';
          }
        }
      }

      var selectedServicePoint = localStorage.getItem("SearchedSelectedServicePoint");
      if (this.checkIsServicePointAvailable() && selectedServicePoint) {
        searchArr.ServicePoint = (JSON.parse(selectedServicePoint)).id;
      }

      var searchString = Object.keys(searchArr).map(key => key + '=' + searchArr[key]).join('&');

      strDyn = "?per_page=" + this.pageSize + "&page=" + this.currentPage + "&sort_order=" + this.selectedSortDir + "&sort_by=" + this.selectedSort + '&with=["image","brand", "model", "tyre_category", "tyreSeason"]&' + searchString;

      this.noDataFoundStatus = false;

      await ApiService.get('/products' + strDyn)
          .then(response => {

            this.totalProducts = response.data.total;
            this.totalPage = response.data.last_page;
            this.products = response.data.data

            var gtag_products = [];

            this.products.forEach(function (product) {
              gtag_products.push({
                'item_id': product.id,
                'item_name': product.name,
                'affiliation': product.car_type,
                'price': product.net_price,
                'type_id': product.id,
                'quantity': product.available_quantity,
                'item_brand': product.brand_name,
                'item_category': product.car_type,
              })
            })

            this.googleTagViewItemList(gtag_products)

            // this.$gtag.event('view_item_list', {
            //     item_list_id: "related_products",
            //     item_list_name: "Related products",
            //     items: gtag_products
            // })

            if (response.data.data.length == 0) {
              this.noDataFoundStatus = true;
            } else {
              this.noDataFoundStatus = false;
            }

          }).catch(error => {

          }).finally(() => {
            this.loading = false;
          });
    },
    async getDynamicFilters(from) {

      var searchArrFilters = new Object();

      if (this.vehicleType) {
        searchArrFilters.vehicle_type = '[' + JSON.stringify(this.vehicleType) + ']';
      }

      if (this.searchBySize.width) {
        searchArrFilters.width = '[' + JSON.stringify(this.searchBySize.width) + ']';
        searchArrFilters.height = '[' + JSON.stringify(this.searchBySize.height) + ']';
        searchArrFilters.diameter = '[' + JSON.stringify(this.searchBySize.diameter) + ']';
      } else if (this.$route.query.licenceplate) {
        searchArrFilters.licencePlate = this.searchBySize.licencePlate;
      }

      if (this.selectedBrands.length != 0 && this.brands.length != 0) {
        var bandsList = this.brands;
        var selectedBrandsId = [];
        this.selectedBrands.find(function (element) {
          var brand = bandsList.find(brand => brand.name === element);
          if(brand) {
            selectedBrandsId.push(brand.id);
          }
        });
        searchArrFilters.brand_id = '[' + selectedBrandsId + ']';
      }

      if (this.selectedSpeedIndexes.length != 0) {
        searchArrFilters.speed_index = JSON.stringify(this.selectedSpeedIndexes);
      } else if (this.searchBySize.speedIndex) {
        searchArrFilters.speed_index = '[' + this.searchBySize.speedIndex + ']';
      }

      var tyreSeasonsArr = [];

      if (Array.isArray(this.selectedTyreSeasons) && this.selectedTyreSeasons.length != 0) {
        tyreSeasonsArr = this.selectedTyreSeasons;
      } else if (this.searchBySize.tyreSeason) {
        tyreSeasonsArr = this.searchBySize.tyreSeason;
      }


      if (tyreSeasonsArr.length != 0 && this.tyreSeasons.length != 0) {
        var tyreSeasonsList = this.tyreSeasons;
        var selectedTyreSeasonsId = [];
        tyreSeasonsArr.find(function (element) {
          var tyreSeasonId = tyreSeasonsList.find(tyreSeason => tyreSeason.name === element).id;
          selectedTyreSeasonsId.push(tyreSeasonId);
        });
        searchArrFilters.tyre_season_id = '[' + selectedTyreSeasonsId + ']';
      }

      if (this.selectedWetGrips.length != 0) {
        searchArrFilters.wet_grip = JSON.stringify(this.selectedWetGrips);
      }

      if (this.selectedNoiseClasses.length != 0) {
        searchArrFilters.noise_class = JSON.stringify(this.selectedNoiseClasses);
      }

      if (this.selectedNoiseValues.length != 0) {
        searchArrFilters.noise_value = JSON.stringify(this.selectedNoiseValues);
      }

      if (this.selectedFuelEfficiencies.length != 0) {
        searchArrFilters.fuel_efficiency = JSON.stringify(this.selectedFuelEfficiencies);
      }

      if (this.selectedLoadIndexes.length != 0) {
        searchArrFilters.load_index = JSON.stringify(this.selectedLoadIndexes);
      }

      if (from == "price_ranges") {
        if (this.selectedPriceRanges.length != 0) {
          if (this.selectedPriceRanges[1] != 0 && this.selectedPriceRanges[0] != 0) {
            searchArrFilters.price_lte = parseInt(this.selectedPriceRanges[1]);
            searchArrFilters.price_gte = parseInt(this.selectedPriceRanges[0]);
          }
        }
      }
      var selectedServicePoint = localStorage.getItem("SearchedSelectedServicePoint");
      if (this.checkIsServicePointAvailable() && selectedServicePoint) {
        searchArrFilters['ServicePoint'] = (JSON.parse(selectedServicePoint)).id;
      }
      var filterString = Object.keys(searchArrFilters).map(key => key + '=' + searchArrFilters[key]).join('&');
      this.getAvailableFilters(filterString);
    },
    changeWidth(seletedWidth) {
      this.resetEnabled = false;

      var getDefaultUrlFilters = this.getUrlFilters();

      this.fetchHeights({"width": this.searchBySize.width, "DynamicFilters": getDefaultUrlFilters});
      this.changeWidthStore(seletedWidth);
      this.searchBySize.height = null;
      this.searchBySize.diameter = null;
    },
    changeHeight(seletedHeight) {
      this.resetEnabled = false;

      this.changeHeightStore(seletedHeight);

      var getDefaultUrlFilters = this.getUrlFilters();

      if (this.searchBySize.height != null) {
        this.fetchDiameters({"searchBySize": this.searchBySize, "DynamicFilters": getDefaultUrlFilters});
      }

      this.searchBySize.diameter = null;
    },
    changeDiameter(seletedDiameter) {
      this.resetEnabled = false;
      this.changeDiameterStore(seletedDiameter);
    },
    async changeVehicleType(cartypeData) {
      // this.carType = cartypeData;
      this.changeCarTypes(cartypeData);
      this.searchBySize.width = null;
      this.searchBySize.height = null;
      this.searchBySize.diameter = null;
      this.searchBySize.tyreSeason = null;
      this.searchBySize.speedIndex = null;

      if (this.searchBySize.width == null || this.searchBySize.height == null || this.searchBySize.diameter == null) {
        this.resetEnabled = false;
      } else {
        this.resetEnabled = true;
      }

      this.products = [];
      this.selectedBrands = [];
      this.selectedTyreSeasons = [];
      this.selectedFuelEfficiencies = [];
      this.selectedWetGrips = [];
      this.selectedNoiseClasses = [];
      this.selectedNoiseValues = [];
      this.selectedSpeedIndexes = [];
      this.selectedLoadIndexes = [];

      this.vehicleType = cartypeData;

      await this.changeUrl();
    },
    searchByTyreSize() {
      this.resetEnabled = !this.resetEnabled;

      if (!this.resetEnabled) {
        this.searchBySize.width = null,
            this.searchBySize.height = null,
            this.searchBySize.diameter = null,
            this.searchBySize.tyreSeason = null,
            this.searchBySize.speedIndex = null
      }

      this.changeUrl()
    },
    async getImageList() {
      await this.getFilters();
      await this.fetchProducts("getImageList");

      this.currentPage = this.currentPage + 1;
    },
    toggleAllTyreSeasons(checked) {
      var selectTyreSeasons = [];
      if (this.tyreSeasons.length != 0) {
        this.tyreSeasons.filter((el) => {
          var element = this.filTyreSeasons.find(fts => fts.name === el.name)
          if(element) {
            selectTyreSeasons.push(el.name);
          }
        });
      }

      this.selectedTyreSeasons = checked ? selectTyreSeasons : []
    },
    toggleAllBrands(checked) {
      var selectBrands = [];
      if (this.brands.length != 0) {
        this.brands.filter((el) => {
          var element = this.filBrands.find(fb => fb.name === el.name)
          if(element) {
            selectBrands.push(el.name);
          }
        });
      }
      this.selectedBrands = checked ? selectBrands : []
    },
    toggleAllSpeedIndexes(checked) {
      var selectSpeedIndexes = [];
      if (this.speedIndexes.length != 0) {
        this.speedIndexes.filter((el) => {
          var element = this.filSpeedIndexes.find(fsi => fsi.speed_index === el.speed_index)
          if (element) {
            selectSpeedIndexes.push(el.speed_index);
          }
        });
      }

      this.selectedSpeedIndexes = checked ? selectSpeedIndexes : []
    },
    toggleAllLoadIndexes(checked) {
      var selectLoadIndexes = [];
      if (this.loadIndexes.length != 0) {
        this.loadIndexes.filter((el) => {
          var element = this.filLoadIndexes.find(fli => fli.load_index === el.load_index)
          if (element) {
            selectLoadIndexes.push(el.load_index);
          }
        });
      }

      this.selectedLoadIndexes = checked ? selectLoadIndexes : []
    },
    toggleAllFuelEfficiencies(checked) {
      var selectFuelEfficiencies = [];
      if (this.fuelEfficiencies.length != 0) {
        this.fuelEfficiencies.filter((el) => {
          var element = this.filFuelEfficiencies.find(ffe => ffe.fuel_efficiency === el.fuel_efficiency)
          if(element) {
            selectFuelEfficiencies.push(el.fuel_efficiency);
          }
        });
      }

      this.selectedFuelEfficiencies = checked ? selectFuelEfficiencies : []
    },
    toggleAllWetGrips(checked) {
      var selectWetGrips = [];
      if (this.wetGrips.length != 0) {
        this.wetGrips.filter((el) => {
          var element = this.filWetGrips.find(fwg => fwg.wet_grip === el.wet_grip)
          if(element) {
            selectWetGrips.push(el.wet_grip);
          }
        });
      }

      this.selectedWetGrips = checked ? selectWetGrips : []
    },
    toggleAllNoiseClasses(checked) {
      var selectNoiseClasses = [];
      if (this.noiseClasses.length != 0) {
        this.noiseClasses.filter((el) => {
          var element = this.filNoiseClasses.find(fnc => fnc.noice_class === el.noice_class)
          if(element) {
            selectNoiseClasses.push(el.noice_class);
          }
        });
      }

      this.selectedNoiseClasses = checked ? selectNoiseClasses : []
    },
    toggleAllNoiseValues(checked) {
      var selectNoiseValues = [];
      if (this.noiseValues.length != 0) {
        this.noiseValues.filter((el) => {
          var element = this.filNoiseValues.find(fnv => fnv.noice_value === el.noice_value)
          if(element) {
            selectNoiseValues.push(el.noice_value);
          }
        });
      }

      this.selectedNoiseValues = checked ? selectNoiseValues : []
    },
    async changeUrl() {

      var selectedSpeedIndexes = [];
      if (this.selectedSpeedIndexes.length != 0) {
        selectedSpeedIndexes = this.selectedSpeedIndexes;
      } else if (this.searchBySize.speedIndex) {
        selectedSpeedIndexes = [this.searchBySize.speedIndex];
        this.selectedSpeedIndexes = [this.searchBySize.speedIndex];
      }

      var selectedTyreSeasons = [];

      if (this.selectedTyreSeasons.length != 0) {
        selectedTyreSeasons = this.selectedTyreSeasons;
      } else if (this.searchBySize.tyreSeason) {
        selectedTyreSeasons = [this.searchBySize.tyreSeason];
        this.selectedTyreSeasons = [this.searchBySize.tyreSeason];
      }

      var selectedBrands = this.selectedBrands;
      // var selectedCategories = this.selectedCategories;
      // var selectedSpeedIndexes = this.selectedSpeedIndexes;
      // var selectedTyreSeasons = this.selectedTyreSeasons;
      var selectedWetGrips = this.selectedWetGrips;
      var selectedNoiseClasses = this.selectedNoiseClasses;
      var selectedNoiseValues = this.selectedNoiseValues;
      var selectedFuelEfficiencies = this.selectedFuelEfficiencies;
      var selectedLoadIndexes = this.selectedLoadIndexes;

      var queryParams = new Object();

      if (this.searchBySize.width && this.searchBySize.width != null) {
        queryParams.width = this.searchBySize.width;
        if (this.vehicleType === 'Car') {
          localStorage.setItem('car_selected_width', this.searchBySize.width)
        } else if (this.vehicleType === 'Light Truck') {
          localStorage.setItem('van_selected_width', this.searchBySize.width)
        }
      }

      if (this.searchBySize.height && this.searchBySize.height != null) {
        queryParams.height = this.searchBySize.height;
        if (this.vehicleType === 'Car') {
          localStorage.setItem('car_selected_aspect_ratio', this.searchBySize.height)
        } else if (this.vehicleType === 'Light Truck') {
          localStorage.setItem('van_selected_aspect_ratio', this.searchBySize.height)
        }
      }

      if (this.searchBySize.diameter && this.searchBySize.diameter != null) {
        queryParams.diameter = this.searchBySize.diameter;
        if (this.vehicleType === 'Car') {
          localStorage.setItem('car_selected_diameter', this.searchBySize.diameter)
        } else if (this.vehicleType === 'Light Truck') {
          localStorage.setItem('van_selected_diameter', this.searchBySize.diameter)
        }
      }

      if(selectedTyreSeasons && selectedTyreSeasons.length) {
        if (this.vehicleType === 'Car') {
          localStorage.setItem('car_selected_season', selectedTyreSeasons[0])
        } else if (this.vehicleType === 'Light Truck') {
          localStorage.setItem('van_selected_season', selectedTyreSeasons[0])
        }
      }

      queryParams.speed_index = selectedSpeedIndexes;
      queryParams.brand = selectedBrands;
      queryParams.tyre_season = selectedTyreSeasons;
      queryParams.wet_grip = selectedWetGrips;
      queryParams.noise_class = selectedNoiseClasses;
      queryParams.noise_value = selectedNoiseValues;
      queryParams.fuel_efficiency = selectedFuelEfficiencies;
      queryParams.load_index = selectedLoadIndexes;

      this.products = [];
      this.currentPage = 1;

      var selectedServicePoint = localStorage.getItem("SearchedSelectedServicePoint");
      if (selectedServicePoint) {
        queryParams["ServicePoint"] = this.normalizeString((JSON.parse(selectedServicePoint)).company_name);
      }

      await this.getTyreCategoryByVehicleType(this.vehicleType)

      var route_name = this.currentLang === 'en_GB' ? 'product_list_by_vehicle_type' : 'product_list_by_vehicle_type_fi'
      var route_param_vt = this.currentLang === 'en_GB' ? this.tyre_category.slug_en : this.tyre_category.slug_fi
      var route = {
        name: route_name,
        query: queryParams
      }
      if (route_param_vt) {
        route.params = {vehicletype: route_param_vt}
      }
      this.$router.push(route, () => {

      }, async () => {
        this.products = [];
        this.currentPage = 1;
        await this.getDynamicFilters("route_query");
        await this.fetchProducts("route_query");
        this.indeterminateAndSelectedAllApply()
      })
    },
    async sort(value) {

      this.products = [];
      this.currentPage = 1;

      this.selectedSort = value.Name;
      this.selectedSortDir = value.order;

      this.products = [];
      this.currentPage = 1;
      await this.fetchProducts("sort");
    },
    addProductToCart(product) {
      this.loading = true

      product.qty = (parseInt(product.qty) > parseInt(product.available_quantity)) ? product.available_quantity : product.qty
      if (this.cartProducts.length > 0) {
        const productIndex = _.findIndex(this.cartProducts, function (cartProduct) {
          return cartProduct.type_id == product.type_id;
        });
        if (productIndex > -1) {
          let cartQuantity = parseInt(this.cartProducts[productIndex].qty)
          let productQuantity = parseInt(product.qty)
          let totalQuantity = cartQuantity + productQuantity

          if (cartQuantity == product.available_quantity || totalQuantity > product.available_quantity) {
            product.qty = product.available_quantity
          } else {
            product.qty = cartQuantity + product.qty
          }
        }
      }

      this.addProduct(product)
          .then(response => {
            this.showSuccessAlert = 5
          })
          .finally(() => {
            this.getAllCartProducts().finally(() => {
              this.loading = false
              /*this.$root.$emit('showQuickCart', true);*/
              this.$bvModal.show('got_to_checkout_popup')
            })

            // gtag page details
            this.googleTagPageDetails(product.name)

            // gtag view item
            this.googleTagViewItems(product)

            // gtag select item
            this.googleTagSelectItem(product);

            // this.$gtag.event('select_item', {
            //     item_list_id: "related_products",
            //     item_list_name: "Related products",
            //     items: [{
            //         'item_id': product.type_id,
            //         'item_name': product.name,
            //         // 'page_title': product.name,
            //         'price': product.net_price,
            //         // 'net_price': product.net_price,
            //         // 'qty': product.qty,
            //         'quantity': product.qty,
            //         'type_id': product.type_id
            //     }]
            // })


            // Add add_to_cart event
            this.googleTagAddToCart(product.net_price, product);

            this.klaviyoTrackAddToCart(product.main_product);
            // this.$gtag.event('add_to_cart', {
            //     currency: "€",
            //     value: product.net_price,
            //     items: [{
            //         'item_id': product.type_id,
            //         'item_name': product.name,
            //         // 'page_title': product.name,
            //         'price': product.net_price,
            //         // 'net_price': product.net_price,
            //         // 'qty': product.qty,
            //         'quantity': product.qty,
            //         'type_id': product.type_id
            //     }]
            // })

          });
    },
    trackAddToCart(productId, productName) {
      window._kl.push(['track', 'Added to Cart', {
        ProductID: productId,
        ProductName: productName
      }]);
    },
    addCurrentProduct(product) {
      this.currentProduct(product);
    },
    async selectedPriceRangesChange() {

      this.products = [];
      this.currentPage = 1;
      await this.getDynamicFilters("price_ranges")

      await this.fetchProducts("price_ranges");
    },
    checkFilSpeedIndexes(speedIndexId) {

      var speedIndexStatus = true;

      this.filSpeedIndexes.filter((el) => {
        if (el.speed_index == speedIndexId) {
          speedIndexStatus = false;
        }
      });
      return speedIndexStatus;
    },
    checkFilTyreSeasons(tyreSeasonId) {

      var tyreSeasonStatus = true;

      this.filTyreSeasons.filter((el) => {
        if (el.id == tyreSeasonId) {
          tyreSeasonStatus = false;
        }
      });
      return tyreSeasonStatus;
    },
    checkFilBrands(brandid) {

      var brandStatus = true;

      this.filBrands.filter((el) => {
        if (el.id == brandid) {
          brandStatus = false;
        }
      });
      return brandStatus;
    },
    checkFilFuelEfficiencies(fuelEfficiencyId) {

      var fuelEfficiencyStatus = true;

      this.filFuelEfficiencies.filter((el) => {
        if (el.fuel_efficiency == fuelEfficiencyId) {
          fuelEfficiencyStatus = false;
        }
      });
      return fuelEfficiencyStatus;
    },
    checkFilWetGrips(wetGripId) {

      var wetGripStatus = true;

      this.filWetGrips.filter((el) => {
        if (el.wet_grip == wetGripId) {
          wetGripStatus = false;
        }
      });
      return wetGripStatus;
    },
    checkNoiseClasses(noiseClassesId) {

      var noiseClassesStatus = true;

      this.filNoiseClasses.filter((el) => {
        if (el.noice_class == noiseClassesId) {
          noiseClassesStatus = false;
        }
      });
      return noiseClassesStatus;
    },
    checkNoiseValues(noiseValueId) {
      var noiseValueStatus = true;

      this.filNoiseValues.filter((el) => {
        if (el.noice_value == noiseValueId) {
          noiseValueStatus = false;
        }
      });
      return noiseValueStatus;
    },
    checkFilLoadIndexes(loadIndexId) {
      var loadIndexStatus = true;

      this.filLoadIndexes.filter((el) => {
        if (el.load_index == loadIndexId) {
          loadIndexStatus = false;
        }
      });
      return loadIndexStatus;
      //loadIndex.load_index
    },
    updatePage(pageSize) {
    },
    setCurrency(total) {
      return total.replace(".", ",") + this.moneySign;
    },
    myFilter: function () {
      this.isActive = !this.isActive;
      // some code to filter users
    },
    getUrlFilters() {
      var searchArrFilters = {};

      if (this.vehicleType) {
        this.vehicleType = this.titleCase(this.vehicleType)
        searchArrFilters.vehicle_type = '[' + JSON.stringify(this.vehicleType) + ']';
      }

      // if(this.selectedBrands.length != 0 && this.brands.length == 0) {
      //     await this.fetchAllBrands();
      // }

      if (this.selectedBrands.length != 0 && this.brands.length != 0) {
        var bandsList = this.brands;
        var selectedBrandsId = [];
        this.selectedBrands.find(function (element) {
          var brandId = bandsList.find(brand => brand.name === element).id;
          selectedBrandsId.push(brandId);
        });
        searchArrFilters.brand_id = '[' + selectedBrandsId + ']';
      }

      if (this.selectedSpeedIndexes.length != 0) {
        searchArrFilters.speed_index = JSON.stringify(this.selectedSpeedIndexes);
      } else if (this.searchBySize.speedIndex) {
        searchArrFilters.speed_index = '[' + this.searchBySize.speedIndex + ']';
      }

      var tyreSeasonsArr = [];

      if (Array.isArray(this.selectedTyreSeasons) && this.selectedTyreSeasons.length != 0) {
        tyreSeasonsArr = this.selectedTyreSeasons;
      } else if (this.searchBySize.tyreSeason) {
        tyreSeasonsArr = this.searchBySize.tyreSeason;
      }

      // if(tyreSeasonsArr.length != 0 && this.tyreSeasons.length == 0) {
      //     this.fetchAllTyreSeasons();

      //     this.setTyreSeasons(this.allTyreSeasons);
      // }

      if (tyreSeasonsArr.length != 0 && this.tyreSeasons.length != 0) {
        var tyreSeasonsList = this.tyreSeasons;
        var selectedTyreSeasonsId = [];
        var found = tyreSeasonsArr.find(function (element) {
          var tyreSeasonId = tyreSeasonsList.find(tyreSeason => tyreSeason.name === element).id;
          selectedTyreSeasonsId.push(tyreSeasonId);
        });
        searchArrFilters.tyre_season_id = '[' + selectedTyreSeasonsId + ']';
      }

      if (this.selectedWetGrips.length != 0) {
        searchArrFilters.wet_grip = JSON.stringify(this.selectedWetGrips);
      }

      if (this.selectedNoiseClasses.length != 0) {
        searchArrFilters.noise_class = JSON.stringify(this.selectedNoiseClasses);
      }

      if (this.selectedNoiseValues.length != 0) {
        searchArrFilters.noise_value = JSON.stringify(this.selectedNoiseValues);
      }

      if (this.selectedFuelEfficiencies.length != 0) {
        searchArrFilters.fuel_efficiency = JSON.stringify(this.selectedFuelEfficiencies);
      }

      if (this.selectedLoadIndexes.length != 0) {
        searchArrFilters.load_index = JSON.stringify(this.selectedLoadIndexes);
      }

      var selectedServicePoint = localStorage.getItem("SearchedSelectedServicePoint");
      if (this.checkIsServicePointAvailable() && selectedServicePoint) {
        searchArrFilters.ServicePoint = (JSON.parse(selectedServicePoint)).id;
      }
      var filterString = "";
      if (searchArrFilters.length != 0) {
        filterString = "&" + Object.keys(searchArrFilters).map(key => key + '=' + searchArrFilters[key]).join('&');
      }
      return filterString;
    },
    getImageURL(product) {
      return "backgroundImage: url('" + product.image.image_base_path + product.image.path + "')";
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    },

    getAddressData(place, placeResultData) {
      this.tempAddress = placeResultData
      localStorage.setItem('GoogleAddress', JSON.stringify(place))
      localStorage.setItem('GoogleSelectedPlace', JSON.stringify(placeResultData))
      this.address = placeResultData.formatted_address;
      this.searchServicePoints();
    },

    setAddressManually() {
      if ("GoogleSelectedPlace" in localStorage) {
        const placeResultData = JSON.parse(localStorage.getItem("GoogleSelectedPlace"))
        this.address = placeResultData.formatted_address;
        this.searchServicePoints();
      }
    },

    searchServicePoints(lang = "") {
      if (!("GoogleAddress" in localStorage)) {
        this.$refs.autocomplete && this.$refs.autocomplete.focus();
        return;
      }
      this.servicepointloading = true
      let params = '';
      const Address = localStorage.getItem('GoogleAddress');
      let addressCoordinates = (Address) ? JSON.parse(Address) : null
      if (addressCoordinates && addressCoordinates.latitude) {
        params = 'latitude=' + addressCoordinates.latitude
      }
      if (addressCoordinates && addressCoordinates.longitude) {
        params = params + '&longitude=' + parseFloat(addressCoordinates.longitude).toFixed(8)
      }

      let locale_code = (this.currentLang == '') ? 'fi_FI' : this.currentLang
      let locale_id = (locale_code == 'en_GB') ? 1 : 2
      params = params + '&locale_id=' + locale_id
      params = params + '&with=["timeSlots","workingDays"]'
      params = params + '&search_radius=' + this.defaultKilometer
      params = params + '&vehicle_type=' + this.default_v_t

      this.fetchDealers(params).finally(() => {
        this.servicepointloading = false
        this.sortSearchedServicePoints()
      })

      this.setSearchedZipcode(this.address);
      this.showServices = true;
    },
    async selectAndRemoveServicePoint(ServicePoint) {
      if (this.selectedServicePoint != null && this.selectedServicePoint.id == ServicePoint.id) {
        this.setSelectedServicePoint(null);
        await this.removeSelectedServicePoint();
      } else {
        this.setSelectedServicePoint(ServicePoint);
        localStorage.setItem("SearchedSelectedServicePoint", JSON.stringify(ServicePoint))
      }
    },
    async removeSelectedServicePoint() {
      localStorage.removeItem("SearchedSelectedServicePoint")
      await this.fetchVehicleTypes();
    },
    async startSearchOnNewServicePoint(option) {
      this.$bvModal.hide('modal-1');
      this.setSelectedServicePoint(option);
      localStorage.setItem("SearchedSelectedServicePoint", JSON.stringify(option))
      var QS = {}
      var selectedServicePoint = localStorage.getItem("SearchedSelectedServicePoint");
      if (selectedServicePoint) {
        QS['ServicePoint'] = (JSON.parse(selectedServicePoint)).id;
      }
      await this.fetchVehicleTypes(QS);
      /*this.vehicleType = this.vehicleTypes[0].car_type;*/
      this.resetTheFilter(this.vehicleTypes[0].car_type)
      /*const QueryString = {
        ServicePoint : this.normalizeString(option.company_name)
      }
      this.$router.push({name : 'search-by-tyre-size', params: { vehicletype: this.vehicleTypes[0].car_type }, query: QueryString, replace : true})*/
    },
    checkIsServicePointAvailable() {
      if (this.$route.query.hasOwnProperty("ServicePoint") && this.$route.query.ServicePoint != "") {
        return true;
      }
      return false;
    },
    async resetAllFilter() {
      localStorage.removeItem("SearchedSelectedServicePoint")
      await this.fetchVehicleTypes();
      await this.resetTheFilter(this.vehicleTypes[0].car_type)
    },

    async resetTheFilter(CarType) {
      this.searchBySize.width = null;
      this.searchBySize.height = null;
      this.searchBySize.diameter = null;
      this.searchBySize.tyreSeason = null;
      this.searchBySize.speedIndex = null;

      if (this.searchBySize.width == null || this.searchBySize.height == null || this.searchBySize.diameter == null) {
        this.resetEnabled = false;
      } else {
        this.resetEnabled = true;
      }

      this.products = [];
      this.selectedBrands = [];
      this.selectedTyreSeasons = [];
      this.selectedFuelEfficiencies = [];
      this.selectedWetGrips = [];
      this.selectedNoiseClasses = [];
      this.selectedNoiseValues = [];
      this.selectedSpeedIndexes = [];
      this.selectedLoadIndexes = [];

      this.vehicleType = CarType;
      this.setFilPriceRanges([]);

      localStorage.removeItem('car_selected_width')
      localStorage.removeItem('car_selected_aspect_ratio')
      localStorage.removeItem('car_selected_diameter')
      localStorage.removeItem('car_selected_season')
      localStorage.removeItem('van_selected_width')
      localStorage.removeItem('van_selected_aspect_ratio')
      localStorage.removeItem('van_selected_diameter')
      localStorage.removeItem('van_selected_season')

      await this.changeUrl();
    },
    async move_to_size() {
      this.products = this.selectedTyreSeasons = this.selectedBrands = this.selectedSpeedIndexes = this.selectedFuelEfficiencies = this.selectedWetGrips = this.selectedNoiseClasses = this.selectedNoiseValues = this.selectedLoadIndexes = [];
      await this.changeUrl();
    },
    async move_to_tyre_season(tyre_season) {
      this.selectedTyreSeasons = [tyre_season]
      this.products = this.selectedBrands = this.selectedSpeedIndexes = this.selectedFuelEfficiencies = this.selectedWetGrips = this.selectedNoiseClasses = this.selectedNoiseValues = this.selectedLoadIndexes = [];
      await this.changeUrl();
    },
    async move_to_brand(brand_name) {
      this.selectedBrands = [brand_name];
      this.products = this.selectedSpeedIndexes = this.selectedFuelEfficiencies = this.selectedWetGrips = this.selectedNoiseClasses = this.selectedNoiseValues = this.selectedLoadIndexes = [];
      await this.changeUrl();
    },
    async move_to_speed_index(speed_index){
      this.selectedSpeedIndexes = [speed_index];
      this.products = this.selectedFuelEfficiencies = this.selectedWetGrips = this.selectedNoiseClasses = this.selectedNoiseValues = this.selectedLoadIndexes = [];
      await this.changeUrl();
    },
    async move_to_fuel_efficiency(fuel_efficiency){
      this.selectedFuelEfficiencies = [fuel_efficiency];
      this.products = this.selectedWetGrips = this.selectedNoiseClasses = this.selectedNoiseValues = this.selectedLoadIndexes = [];
      await this.changeUrl();
    },
    async move_to_wet_grip(wet_grip){
      this.selectedWetGrips = [wet_grip];
      this.products = this.selectedNoiseClasses = this.selectedNoiseValues = this.selectedLoadIndexes = [];
      await this.changeUrl();
    },
    async move_to_noise_class(noise_class){
      this.selectedNoiseClasses = [noise_class];
      this.products = this.selectedNoiseValues = this.selectedLoadIndexes = [];
      await this.changeUrl();
    },
    async move_to_noise_value(noise_value){
      this.selectedNoiseValues = [noise_value];
      this.products  = this.selectedLoadIndexes = [];
      await this.changeUrl();
    },
    async move_to_load_index(load_index){
      this.selectedLoadIndexes = [load_index];
      this.products  = [];
      await this.changeUrl();
    },
    clearSearchedServicePoint() {
      localStorage.removeItem('GoogleAddress')
      localStorage.removeItem('GoogleSelectedPlace')
      localStorage.removeItem('DefaultKilometer')
      localStorage.removeItem('Default_V_T')
      this.defaultKilometer = 100
      this.default_v_t = 1
      this.address = ''
      this.showServices = false
      this.setSelectedServicePoint(null)
      /*--For Home Page Reset Start--*/
      this.setShowServices(false)
      this.setAddress("")
      this.setDefaultVT(1)
      this.setDefaultKilometer(100)
      this.setDefaultSort(0)
      /*--For Home Page Reset Stop--*/
      this.$refs.autocomplete && (this.$refs.autocomplete.$el.value = '')
      this.setDealers([])
      this.resetAllFilter()
    },
    sortSearchedServicePoints() {
      let data = null;
      switch (this.defaultSort) {
        case 0:
          data = this.service_points.sort((a, b) => {
            return parseFloat(a.distance_km).toFixed(2) - parseFloat(b.distance_km).toFixed(2)
          })
          break;
        case 1:
          data = this.service_points.sort((a, b) => {
            return parseFloat(b.distance_km).toFixed(2) - parseFloat(a.distance_km).toFixed(2)
          })
          break;
        case 2:
          data = this.service_points.sort((a, b) => {
            return ((a.company_name == b.company_name) ? 0 : ((a.company_name > b.company_name) ? 1 : -1))
          })
          break;
        case 3:
          data = this.service_points.sort((a, b) => {
            return ((a.company_name == b.company_name) ? 0 : ((a.company_name < b.company_name) ? 1 : -1))
          })
          break;
      }
      this.setDealers(data)
    },
    removeAppointmentPopup() {
      this.showModal = false
    },
    async VehicleType() {
      let vehicle_type = this.$route.params.vehicletype
      if (this.$route.name === 'product_list_by_vehicle_type' || this.$route.name === 'product_list_by_vehicle_type_fi') {
        if (vehicle_type === '' || vehicle_type === undefined) {
          vehicle_type = 'All'
        }
        await this.getVTS(vehicle_type)
        vehicle_type = this.vts.vehicle_type
      }
      return vehicle_type
    },
    modifyQueryAndReplaceURL(ObjectKey, ObjectVal) {
      var source = {[ObjectKey]: ObjectVal}
      var new_query = Object.assign({}, this.$route.query, source)
      this.$router.push({query: new_query, replace: true})
    },
    indeterminateAndSelectedAllApply() {
      var brands = this.brands.filter(brand => this.filBrands.some(fillBrand => fillBrand.id === brand.id))
      this.allSelectedBrands = (this.selectedBrands.length > 0 && this.selectedBrands.length === brands.length) ? true : false
      this.indeterminateBrands = (this.selectedBrands.length > 0 && this.selectedBrands.length !== brands.length) ? true : false

      var tyreSeasons = this.tyreSeasons.filter(ts => this.filTyreSeasons.some(fts => fts.id === ts.id))
      this.allSelectedTyreSeasons = (this.selectedTyreSeasons.length > 0 && this.selectedTyreSeasons.length === tyreSeasons.length) ? true : false
      this.indeterminateTyreSeasons = (this.selectedTyreSeasons.length > 0 && this.selectedTyreSeasons.length !== tyreSeasons.length) ? true : false

      var speedIndexes = this.speedIndexes.filter(si => this.filSpeedIndexes.some(fsi => fsi.speed_index === si.speed_index))
      this.allSelectedSpeedIndexes = (this.selectedSpeedIndexes.length > 0 && this.selectedSpeedIndexes.length === speedIndexes.length) ? true : false
      this.indeterminateSpeedIndexes = (this.selectedSpeedIndexes.length > 0 && this.selectedSpeedIndexes.length !== speedIndexes.length) ? true : false

      var loadIndexes = this.loadIndexes.filter(li => this.filLoadIndexes.some(sli => sli.load_index === li.load_index))
      this.allSelectedLoadIndexes = (this.selectedLoadIndexes.length > 0 && this.selectedLoadIndexes.length === loadIndexes.length) ? true : false
      this.indeterminateLoadIndexes = (this.selectedLoadIndexes.length > 0 && this.selectedLoadIndexes.length !== loadIndexes.length) ? true : false

      var fuelEfficiencies = this.fuelEfficiencies.filter(fe => this.filFuelEfficiencies.some(ffe => ffe.fuel_effiency === fe.fuel_effiency))
      this.allSelectedFuelEfficiencies = (this.selectedFuelEfficiencies.length > 0 && this.selectedFuelEfficiencies.length === fuelEfficiencies.length) ? true : false
      this.indeterminateFuelEfficiencies = (this.selectedFuelEfficiencies.length > 0 && this.selectedFuelEfficiencies.length !== fuelEfficiencies.length) ? true : false

      var wetGrips = this.wetGrips.filter(wg => this.filWetGrips.some(fwg => fwg.wet_grip === wg.wet_grip))
      this.allSelectedWetGrips = (this.selectedWetGrips.length > 0 && this.selectedWetGrips.length === wetGrips.length) ? true : false
      this.indeterminateWetGrips = (this.selectedWetGrips.length > 0 && this.selectedWetGrips.length !== wetGrips.length) ? true : false

      var noiseClasses = this.noiseClasses.filter(nc => this.filNoiseClasses.some(fnc => fnc.noice_class === nc.noice_class))
      this.allSelectedNoiseClasses = (this.selectedNoiseClasses.length > 0 && this.selectedNoiseClasses.length === noiseClasses.length) ? true : false
      this.indeterminateNoiseClasses = (this.selectedNoiseClasses.length > 0 && this.selectedNoiseClasses.length !== noiseClasses.length) ? true : false

      var noiseValues = this.noiseValues.filter(nv => this.filNoiseValues.some(fnv => fnv.noice_value === nv.noice_value))
      this.allSelectedNoiseValues = (this.selectedNoiseValues.length > 0 && this.selectedNoiseValues.length === noiseValues.length) ? true : false
      this.indeterminateNoiseValues = (this.selectedNoiseValues.length > 0 && this.selectedNoiseValues.length !== noiseValues.length) ? true : false
    }
  }
};


</script>

<style media="screen">
.rc-block {
  display: flex !important;
  align-items: center !important;
  line-height: normal !important;
  text-align: justify !important;
  margin-top: 4px !important;
}

.rc-label-span {
  margin-left: 3px !important;
}

/* .images-item, .product-item{ */
.images-item {
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-name: fadeInUp;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10%) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(0%) scale(1.0);
  }
}

.vue-slider-dot, .vue-slider-process, .vue-slider-rail {
  background: black;
}

ul#service-point-address {
  list-style: none;
  padding: 0;
  margin-left: 25px;
}

ul#service-point-address li {
  word-break: break-all;
}

ul#service-point-address li:before {
  font-family: "Font Awesome 5 Free";
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  font-weight: 900;
  margin-left: -1.5em; /* same as padding-left set on li */
  width: 1.5em; /* same as padding-left set on li */
}

ul#service-point-address li#distance-icon:before {
  content: "\f018";
}

ul#service-point-address li#address-icon:before {
  content: "\f041";
}

ul#service-point-address li#organization-name:before {
  content: "\f1ad";
}

ul#service-point-address li#time-icon:before {
  content: "\f017";
}

ul#service-point-address li#phone-icon:before {
  content: "\f095";
}

ul#service-point-address li#organization-name,
ul#service-point-address li#distance-icon {
  margin-bottom: 10px;
}

#modal-1 .modal-dialog {
  max-width: 900px !important;
}

.flex-grow-1 {
  flex: 1 !important;
}

</style>

<style>
.custom-dropdown {
  position: relative;
  display: inline-block;
}

.custom-dropdown-toggle {
  cursor: pointer;
  font-size: 18px;
  margin-top: 5px;
}

.custom-dropdown-toggle:hover {
  background-color: #e2e6ea; /* Darker gray on hover, similar to Bootstrap */
}

.custom-dropdown-menu {
  display: none;
  position: absolute;
  background-color: #fff;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1;
  min-width: 160px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0;
  margin: 0;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
}

.custom-dropdown-item {
  color: #007bff;
  padding: 8px 16px;
  text-decoration: none;
  display: block;
  background-color: #fff;
  cursor: pointer;
}

.custom-dropdown-item:hover {
  background-color: #f1f1f1; /* Light gray background on hover */
}

.custom-dropdown:hover .custom-dropdown-menu {
  display: block;
}

/* Custom scrollbar for WebKit browsers */
.custom-dropdown-menu::-webkit-scrollbar {
  width: 8px; /* Set the width of the scrollbar */
}

.custom-dropdown-menu::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background color of the scrollbar track */
}

.custom-dropdown-menu::-webkit-scrollbar-thumb {
  background-color: #888; /* Color of the scrollbar thumb */
  border-radius: 10px; /* Rounded corners of the scrollbar thumb */
  border: 2px solid #f1f1f1; /* Optional border around the scrollbar thumb */
}

/* Custom scrollbar for Firefox */
.custom-dropdown-menu {
  scrollbar-width: thin; /* Set the scrollbar width to thin */
  scrollbar-color: #888 #f1f1f1; /* Color of the scrollbar thumb and track */
}

.custom-breadcrumb-item.make-link {
  cursor: pointer;
  color: #007bff;
}
</style>